import moment from 'moment';

var FormProInternal = (function ($) {
    const calculationModeValue = {
        0: "sum",
        1: "average",
        2: "count",
        3: "sum",
        4: "count",
        5: "editable"
    };

    function calculationModeFormat(calculationMode, numFormat) {
        if (!calculationMode || calculationMode == 1|| calculationMode == 0 || calculationMode == 5) return numFormat;
        else return null; // count or average
    };

   //_NO_ENCODE_PACK_

   // SSF = Server Side Filtering
   var enableSSF = true;

   // lazy loading is only possible when enableSSF==true, it can be, however desactivated independently
   var enableLazyLoading = true;

   // max row count before server side filtering. Also used for lazy loading if enableLazyLoading==true
   var maxRowCountBeforeSSF = 100;

   // when paging how many rows should we load when user click load more
   var moreRowCount = 100;

   // max row count before allowing key up to trigger new filters.
   var maxRowCountBeforeFilterOnKeyUp = 100;

   if(!$) {
       $ = {
        extend: function(){
            for(var i=1; i<arguments.length; i++)
                for(var key in arguments[i])
                    if(arguments[i].hasOwnProperty(key)) {
                        arguments[0][key] = arguments[i][key];
                    }
                    return arguments[0];
                }
        } ;
    }


    function RecordFilter(json) {
        this.predicateString = null;
        this.operand = null;
        this.predicates = {};
        this.predicateStringList = [];
        this.id = null;

        this.registerPredicate('is empty', this.isEmpty, {needOperand: false});
        this.registerPredicate('is not empty', this.isEmpty, {not: true, needOperand: false});

        if (json) {
            this.fromJson(json);
        }
    }

    RecordFilter.prototype = {
        registerPredicate: function (predicateString, testFunction, options) {
            if (!options) {
                options = {};
            }
            this.predicates[predicateString] = {
                testFunction: testFunction,
                not: options.not,
                needAccumulator: options.needAccumulator,
                needOperand: options.needOperand,
                operandNeedFieldId: options.operandNeedFieldId
            };
            if (predicateString != "is empty" && predicateString != "is not empty") {
                this.predicateStringList.push(predicateString);
            }
        },
        unregisterPredicate: function (predicateString) {
            delete this.predicates[predicateString];
            if (predicateString != 'is empty' && predicateString != 'is not empty') {
                for (var i = 0; i < predicateStringList; i++) {
                    if (this.predicateStringList[i] == predicateString) {
                        this.predicateStringList.splice(i, 1);
                        return;
                    }
                }
            }
        },
        clearPredicates: function () {
            this.predicates = {};
            this.predicateStringList = [];
        },
        setPredicate: function (predicateString) {
            this.predicateString = predicateString;
        },
        getPredicate: function () {
            return this.predicateString;
        },
        getPredicateList: function () {
            var tail = [];
            if (this.predicates['is empty']) {
                tail.push('is empty');
            }
            if (this.predicates['is not empty']) {
                tail.push('is not empty');
            }
            return this.predicateStringList.concat(tail);
        },
        isEmpty: function (value) {
            return value === null || value === '' || value === undefined;
        },
        is: function (value) {
            return value === this.operand;
        },
        test: function (value, neededInfos) {
            var predicate = this.predicates[this.predicateString];
            if (!predicate) {
                return true;
            }

            if (predicate.needAccumulator) {
                return false;
            }
            var result = predicate.testFunction.call(this, value, neededInfos);
            return predicate.not ? !result : result;
        },
        /**
         * @param acc Accumulator for filters which return true to method needAccumulator. An object used by accumulator to store state
         * between iterations.
         * @param id An id uniquely identifying value. Can be anything you want.
         * @param result Result must be an empty array. At the end of iterations, it will contain the id's found by accumulator.
         * @param neededInfos a object containing key values pairs with supplementary infos needed by filters.
         * Note: In case accumulator has operand.field_id neededInfos must have at least the folowing
         * {operandTextFieldValue: <the current value of field converted to text>}
         * @see  RecordFilterGroup.filterRows for more info
         *
         * When passed an accumulator this function return true when a new result was found,false otherwise.
         */
        runAccumulator: function (value, acc, id, result, neededInfos) {
            var predicate = this.predicates[this.predicateString];
            if (!predicate) {
                return true;
            }

            return predicate.testFunction.call(this, value, acc, id, result, neededInfos);
        },
        isReady: function () {
            return this.predicateString && (!this.needOperand() || (this.operand !== null && this.operand !== ''));
        },
        setOperand: function (operand) {
            this.operand = operand;
        },
        getOperand: function () {
            return this.operand;
        },
        needOperand: function () {
            return this.predicateString && this.predicates[this.predicateString] && this.predicates[this.predicateString].needOperand;
        },
        operandNeedFieldId: function () {
            return this.predicateString && this.predicates[this.predicateString] && this.predicates[this.predicateString].operandNeedFieldId;
        },
        needAccumulator: function () {
            return this.predicateString && this.predicates[this.predicateString] && this.predicates[this.predicateString].needAccumulator;
        },
        toString: function () {
            var name = "RecordFilter";
            if (this instanceof TextRecordFilter) {
                name = "TextRecordFilter";
            }
            return name + ": predicate=" + this.predicateString + " operand=" + this.operand;
        },
        toJson: function () {
            return {
                predicate: this.predicateString,
                operand: this.operand
            };
        },
        fromJson: function (json) {
            this.operand = json.operand;
            this.predicateString = json.predicate;
            this.id = json.id;
        }
    };

    function createSubclass(parentClass, subClass) {
        subClass.prototype = Object.create(parentClass.prototype);
        subClass.prototype.constructor = subClass;
    };


    function RecordGroupBy(json) {
        RecordFilter.call(this, json);
        this.clearPredicates();

        var dummy = function() {
            return false;
        };
        this.registerPredicate('asc', dummy, {needOperand: false});
        this.registerPredicate('desc', dummy, {needOperand: false});
        if (!json || !this.predicateString) {
            this.predicateString = 'asc';
        }
    };

    createSubclass(RecordFilter,RecordGroupBy);

    RecordGroupBy.prototype.isReady = function () {
        return true;
    };


    function TextRecordFilter(json) {
        RecordFilter.call(this, json);
        this.registerPredicate('contains', this.contains, {needOperand: true});
        this.registerPredicate('does not contain', this.contains, {not: true, needOperand: true});
        this.registerPredicate('is', this.is, {needOperand: true});
        this.registerPredicate('is not', this.is, {not: true, needOperand: true});
        this.registerPredicate('is me', this.isMe, {needOperand: false});
		this.registerPredicate('is book code',this.isBookCode, {needOperand: false});
        this.registerPredicate('begins with', this.beginsWith, {needOperand: true});
        if (!json) {
            this.predicateString = 'contains';
        }
    };

    createSubclass(RecordFilter, TextRecordFilter);
    TextRecordFilter.prototype.contains = function (value) {
        return value !== null && value.toUpperCase().indexOf(this.operand.toUpperCase()) != -1;
    };

    TextRecordFilter.prototype.is = function (value) {
        return value !== null && value.toUpperCase() == this.operand.toUpperCase();
    };

    TextRecordFilter.prototype.isMe = function (value,neededInfos) {
        return isMe(neededInfos,value);
    };

    TextRecordFilter.prototype.beginsWith = function(value){
        return value !== null && value.toUpperCase().startsWith(this.operand.toUpperCase(),0);
    };

	TextRecordFilter.prototype.isBookCode = function(value,neededInfos){
		return isBookCode(neededInfos,value);
	};

    function FilesRecordFilter(json) {
        TextRecordFilter.call(this, json);
    };

    createSubclass(TextRecordFilter, FilesRecordFilter);
    FilesRecordFilter.prototype.contains = function (value) {
        if (value === null) {
            return false;
        }
        for (var i = 0; i < value.length; i++) {
            if (TextRecordFilter.prototype.contains.call(this, value[i].name)) {
                return true;
            }
        }
        return false;
    };

    FilesRecordFilter.prototype.is = function (value) {
        if (value === null) {
            return false;
        }
        for (var i = 0; i < value.length; i++) {
            if (TextRecordFilter.prototype.is.call(this, value[i].name)) {
                return true;
            }
        }
        return false;
    };

    FilesRecordFilter.prototype.isEmpty = function (value) {
        return value === null || value === undefined || value.length == 0;
	};
	
	FilesRecordFilter.prototype.beginsWith = function(value) {
		if (value === null) {
            return false;
        }
        for (var i = 0; i < value.length; i++) {
            if (TextRecordFilter.prototype.beginsWith.call(this, value[i].name)) {
                return true;
            }
        }
        return false;
	}


	function LinksRecordFilter(json) {
        RecordFilter.call(this, json);
        this.registerPredicate('contains', this.contains, {needOperand: true});
        this.registerPredicate('does not contain', this.contains, {not: true, needOperand: true});
        this.registerPredicate('is', this.is, {needOperand: true});
        this.registerPredicate('is not', this.is, {not: true, needOperand: true});
        this.registerPredicate('is me', this.isMe, {needOperand: false});
        this.registerPredicate('begins with', this.beginsWith, {needOperand: true});
        if (!json) {
            this.predicateString = 'contains';
        }
		this.registerPredicate('is any of', this.isAnyOf, {needOperand: true});
		this.registerPredicate('is not any of', this.isAnyOf, {needOperand: true});
	};
	createSubclass(TextRecordFilter,LinksRecordFilter);

	LinksRecordFilter.prototype.contains = function(value) {
		return this._callTestFunction(TextRecordFilter.prototype.contains,value);
	};
	LinksRecordFilter.prototype.is = function(value) {
		return this._callTestFunction(TextRecordFilter.prototype.is,value);
	};
	LinksRecordFilter.prototype.isEmpty = function(value) {
		return value === null || value === undefined || value.length==0;
	};
	LinksRecordFilter.prototype.isAnyOf = function(value) {

	};
	LinksRecordFilter.prototype._callTestFunction = function(f,value) {
        if(value===null) {
            return false;
		}
		
        for(var i=0;i<value.length;i++) {
            if (Array.isArray(value[i].value)) {
                for (var j=0;j<value[i].value.length;j++) {
                    if (isValueFile(value[i].value[j])) {
                        if(f.call(this,value[i].value[j].name)) {
                            return true;
                        }
					}
					else if (Array.isArray(value[i].value[j].value)) {
						if (this._callTestFunction(f, value[i].value[j].value)) {
							return true;
						}
					}
					else if(f.call(this, value[i].value[j].value)) {
						return true;
					}
                }
			}
			else if(f.call(this, value[i].value)) {
                return true;
            }
        }
        return false;
	};

    function UserLinksRecordFilter(json) {
        LinksRecordFilter.call(this,json);
    };
    createSubclass(LinksRecordFilter,UserLinksRecordFilter);

    UserLinksRecordFilter.prototype.isMe = function(value,neededInfos) {
        return this._callTestFunction(isMe.bind(this,neededInfos),value);
    };


    function TextLinksRecordFilter(json) {
        LinksRecordFilter.call(this,json);
    };
    createSubclass(LinksRecordFilter,TextLinksRecordFilter);

    TextLinksRecordFilter.prototype.isMe = function(value,neededInfos) {
        return this._callTestFunction(isMe.bind(this,neededInfos),value,value);
    };

    var isMe = function(neededInfos,value) {
        return value !== null &&
            (value.toUpperCase() == neededInfos.utilisateur_code.toUpperCase()
                || value.toUpperCase() == ('@'+neededInfos.utilisateur_code.toUpperCase()) );
    };

	var isBookCode = function(neededInfos,value){
		return value !== null &&
			(value.toUpperCase() == neededInfos.carnet_code.toUpperCase() + "." + needInfos.carnet_owner.toUpperCase());
	};

    function CommentsRecordFilter(json) {
        TextRecordFilter.call(this, json);
    };

    createSubclass(TextRecordFilter, CommentsRecordFilter);
    CommentsRecordFilter.prototype.contains = function (value) {
        if (value === null) {
            return false;
        }
		if (value.last)
			return TextRecordFilter.prototype.contains.call(this, value.last.m);
		else
			return TextRecordFilter.prototype.contains.call(this, '');
    };

    CommentsRecordFilter.prototype.is = function (value) {
        if (value === null) {
            return false;
        }
		if (value.last)
			return TextRecordFilter.prototype.is.call(this, value.last.m);
		else
			return TextRecordFilter.prototype.is.call(this, '');
    };

    CommentsRecordFilter.prototype.isEmpty = function (value) {
        return value === null || value === undefined;
    };

    function EnumRecordFilter(json) {
		RecordFilter.call(this, json);
        this.registerPredicate('is any of', this.isAnyOf, {needOperand: true});
		this.registerPredicate('is not any of', this.isAnyOf, {not: true, needOperand: true});
		this.registerPredicate('contains', this.contains, {needOperand: true});
		this.registerPredicate('does not contain', this.notContains, {not: true, needOperand: true});
		this.registerPredicate('is me', this.isMe, {needOperand: false});
        if (!json) {
            this.predicateString = 'is any of';
        }
    };

    createSubclass(RecordFilter, EnumRecordFilter);

    EnumRecordFilter.prototype.contains = function (value) {
        return value !== null && value.toUpperCase().indexOf(this.operand.toUpperCase()) != -1;
	};
	
	EnumRecordFilter.prototype.notContains = function (value) {
        return value === null || value.toUpperCase().indexOf(this.operand.toUpperCase()) === -1;
    };

    EnumRecordFilter.prototype.isMe = function (value,neededInfos) {
        return isMe(neededInfos,value);
    };


    EnumRecordFilter.prototype.isAnyOf = function (value) {
        for (var i = 0; i < this.operand.length; i++) {
            if (value == this.operand[i]) {
                return true;
            }
        }
        return false;
    };

    EnumRecordFilter.prototype.isReady = function () {
        return this.predicateString == 'is empty' || this.predicateString == 'is not empty' || this.predicateString == 'is me' ||
            (this.predicateString && this.operand && this.operand.length);
    };

    function NumberRecordFilter(json) {
        RecordFilter.call(this);
        this.registerPredicate('equals', this.is, {needOperand: true});
        this.registerPredicate('not equal', this.is, {needOperand: true, not: true});
        this.registerPredicate('less than', this.lessThan, {needOperand: true});
        this.registerPredicate('greater than', this.greaterThan, {needOperand: true});
        this.registerPredicate('less or equal than', this.lessOrEqualThan, {needOperand: true});
        this.registerPredicate('greater or equal than', this.greaterOrEqualThan, {needOperand: true});
        this.registerPredicate('min', this.min, {needOperand: false, needAccumulator: true});
        this.registerPredicate('max', this.max, {needOperand: false, needAccumulator: true});
        this.registerPredicate('bottom', this.bottom, {needOperand: true, needAccumulator: true, operandNeedFieldId: true});
        this.registerPredicate('top', this.top, {needOperand: true, needAccumulator: true, operandNeedFieldId: true});
        if (!json) {
            this.predicateString = 'equals';
        }else {
            this.fromJson(json);
        }
    };

    createSubclass(RecordFilter, NumberRecordFilter);

    //abstract method to implement
    NumberRecordFilter.prototype.parseNumber = function (value) {
        return value;
    };

    NumberRecordFilter.prototype.is = function (value) {
        value = this.parseNumber(value);
        if (isNaN(value)) {
            return false;
        }
        return value === this.operand;
    };

    NumberRecordFilter.prototype.lessThan = function (value) {
        value = this.parseNumber(value);
        if (isNaN(value)) {
            return false;
        }
        return value < this.operand;
    };
    NumberRecordFilter.prototype.greaterThan = function (value) {
        value = this.parseNumber(value);
        if (isNaN(value)) {
            return false;
        }
        return value > this.operand;
    };
    NumberRecordFilter.prototype.lessOrEqualThan = function (value) {
        value = this.parseNumber(value);
        if (isNaN(value)) {
            return false;
        }
        return value <= this.operand;
    };
    NumberRecordFilter.prototype.greaterOrEqualThan = function (value) {
        value = this.parseNumber(value);
        if (isNaN(value)) {
            return false;
        }
        return value >= this.operand;
    };

    NumberRecordFilter.prototype.min = function (value, acc, id, result) {
        value = this.parseNumber(value);
        if (!acc.hasOwnProperty('result')) {
            if (isNaN(value)) {
                return false;
            }
            acc.result = value;
            result.push(id);
            return true;
        }
        if (value < acc.result) {
            acc.result = value;
            result[0] = id;
            return true;
        }
        return false;
    };

    NumberRecordFilter.prototype.max = function (value, acc, id, result) {
        value = this.parseNumber(value);
        if (!acc.hasOwnProperty('result')) {
            if (isNaN(value)) {
                return false;
            }
            acc.result = value;
            result.push(id);
            return true;
        }
        if (value > acc.result) {
            acc.result = value;
            result[0] = id;
            return true;
        }
        return false;
    };


    NumberRecordFilter.prototype.insertInArray = function(items,item,index,maxLength) {
        var tmpItem,lastItem;

        lastItem = item;

        var max = Math.min(items.length+1,maxLength);
        for(var i=index;i<max;i++) {
            tmpItem = items[i];
            items[i] = lastItem;
            lastItem = tmpItem;
        }
    };

    NumberRecordFilter.testValBottom = function(current,old) {
        return current<old;
    };

    NumberRecordFilter.prototype.bottom = function (value, acc, id, result, neededInfos) {
        return this.boundedOrderedAcc(NumberRecordFilter.testValBottom,value, acc, id, result, neededInfos.operandTextFieldValue);
    };

    NumberRecordFilter.prototype.boundedOrderedAcc = function (testVal,value, acc, id, result, operandTextFieldValue) {
        if(typeof operandTextFieldValue!=='undefined') {
            return this.boundedOrderedAccDistinct(testVal,value, acc, id, result, operandTextFieldValue);
        }

        value = this.parseNumber(value);
        if (isNaN(value)) {
            return false;
        }

        if (!acc.hasOwnProperty('result')) {
            acc.result = [];
            acc.result.push(value);
            result.push(id);
            return true;
        }

        for(var i=acc.result.length-1;i>=0;i--) {
            if(!testVal(value,acc.result[i])) {
                break;
            }
        }

        if(i==(acc.result.length-1)) {
            if( acc.result.length==this.operand.value) {
                return false;
            }
            acc.result.push(value);
            result.push(id);
            return true;
        }

        this.insertInArray(acc.result,value,i+1,this.operand.value);
        this.insertInArray(result,id,i+1,this.operand.value);
        return true;
    };

    NumberRecordFilter.prototype.boundedOrderedAccDistinct = function (testVal,value, acc, id, result, operandTextFieldValue) {
        value = this.parseNumber(value);
        if (isNaN(value)) {
            return false;
        }

        if (!acc.hasOwnProperty('result')) {
            acc.result = [];
            acc.result.push({value: value,distinctValue: operandTextFieldValue});
            result.push(id);
            return true;
        }

        // first try to find a result with the same operandTextFieldValue
        for(var i=acc.result.length-1;i>=0;i--) {
            if(acc.result[i].distinctValue===operandTextFieldValue) {
                if(testVal(value,acc.result[i].value)) {
                    // found a better match to replace existing entry
                    acc.result[i] = {value: value,distinctValue: operandTextFieldValue};
                    result[i] = id;
                    return true;
                }
                // previous match was better so return false
                return false;
            }
        }

        //if operandTextFieldValue is not already stored in result[n].distinctValue, switch to the classical
        //bounded insertion-sort algo
        for(i=acc.result.length-1;i>=0;i--) {
            if(!testVal(value,acc.result[i].value)) {
                break;
            }
        }

        if(i==(acc.result.length-1)) {
            if( acc.result.length==this.operand.value) {
                return false;
            }
            acc.result.push({value: value,distinctValue: operandTextFieldValue});
            result.push(id);
            return true;
        }

        this.insertInArray(acc.result,{value: value,distinctValue: operandTextFieldValue},i+1,this.operand.value);
        this.insertInArray(result,id,i+1,this.operand.value);
        return true;
    };

    NumberRecordFilter.testValTop = function(current,old) {
        return current>old;
    };

    NumberRecordFilter.prototype.top = function (value, acc, id, result, neededInfos) {
        return this.boundedOrderedAcc(NumberRecordFilter.testValTop,value, acc, id, result, neededInfos.operandTextFieldValue);
    };



    NumberRecordFilter.prototype.fromJson = function (json) {
        RecordFilter.prototype.fromJson.call(this, json);
        if(this.needAccumulator() && this.needOperand()) {
            if(typeof this.operand==='object' && this.operand!==null) {
                this.operand = $.extend({},this.operand,{value: this.operand.value===null ?
                    '' : this.parseNumber(this.operand.value)});
            }else {
                this.operand = { value: this.operand===null ? '' : this.parseNumber(this.operand)};
            }

        }else if(this.operand!==null && this.operand!=''){
            this.operand = this.parseNumber(this.operand);
        }
    };

    NumberRecordFilter.prototype.isReady = function() {
        if( !(this.needAccumulator() && this.needOperand()) ) {
            return RecordFilter.prototype.isReady.call(this);
        }
        return RecordFilter.prototype.isReady.call(this) && this.operand.value!==null && this.operand.value!='';
    };

    function IntRecordFilter(json) {
        NumberRecordFilter.call(this, json);
    };

    createSubclass(NumberRecordFilter, IntRecordFilter);
    IntRecordFilter.prototype.parseNumber = function (value) {
        return parseInt(value, 10);
    };


    function FloatRecordFilter(json) {
        NumberRecordFilter.call(this, json);
    };

    createSubclass(NumberRecordFilter, FloatRecordFilter);
    FloatRecordFilter.prototype.parseNumber = function (value) {
        return parseFloat(value);
    };

    function BooleanRecordFilter(json) {
        RecordFilter.call(this, json);
        this.registerPredicate('is', this.is, {needOperand: true});
        if (!json) {
            this.predicateString = 'is';
            this.operand = 0;
        }
    };

    createSubclass(RecordFilter, BooleanRecordFilter);
    BooleanRecordFilter.prototype.is = function (value) {
		return toBoolean(value)===toBoolean(this.operand);
    };

    BooleanRecordFilter.prototype.fromJson = function (json) {
        RecordFilter.prototype.fromJson.call(this, json);
        this.operand = toBoolean(this.operand) ? 1 : 0;
    };


    function DateRecordFilter(json) {
        RecordFilter.call(this, json);
		this.registerPredicate('on', this.on, {needOperand: true});		
		this.registerPredicate('not on', this.on, {needOperand: true, not: true});		
        this.registerPredicate('before', this.before, {needOperand: true});
        this.registerPredicate('after', this.after, {needOperand: true});
        this.registerPredicate('in month', this.inMonth, {needOperand: true});
        this.registerPredicate('in quarter', this.inQuarter, {needOperand: true});
        this.registerPredicate('in year', this.inYear, {needOperand: true});
		this.registerPredicate('on or before', this.onOrBefore, {needOperand: true});
		this.registerPredicate('on or before today', this.onOrBeforeToday, {needOperand: false});
		this.registerPredicate('before today', this.beforeToday, {needOperand: false});
		this.registerPredicate('on or after', this.onOrAfter, {needOperand: true});
		this.registerPredicate('on or after today', this.onOrAfterToday, {needOperand: false});
		this.registerPredicate('after today', this.afterToday, {needOperand: false});
		this.registerPredicate('today', this.today, {needOperand: false});
		this.registerPredicate('not on today', this.onToday, {needOperand: false, not: true});
        this.registerPredicate('tomorrow', this.tomorrow, {needOperand: false});
		this.registerPredicate('in this week', this.inThisWeek, {needOperand: false});
		this.registerPredicate('in the next x days', this.inTheNextXDays, {needOperand: true});
		this.registerPredicate('current month', this.currentMonth, {needOperand: false});
		this.registerPredicate('current year', this.currentYear, {needOperand: false});
		this.registerPredicate('not current month', this.currentMonth, {needOperand: false, not: true});
		this.registerPredicate('not current year', this.currentYear, {needOperand: false, not: true});
		this.registerPredicate('anniversary', this.anniversary, { needOperand: false, not: false});
		this.registerPredicate('not anniversary', this.anniversary, { needOperand: false, not: true});
        if (!json) {
            this.predicateString = 'on';
        }
    };

    createSubclass(RecordFilter, DateRecordFilter);

    DateRecordFilter.prototype.extractDate = function(value) {
        if(!value) {
            return value;
        }

        if(typeof value == "object"){
            return moment(value.value).format("YYYY-MM-DD");
        }
        return value.substr(0,10);
    };
    DateRecordFilter.prototype.on = function (value) {
        if (!value) {
            return false;
        }
        value = this.extractDate(value);
        return this.operand === value;
	};
	DateRecordFilter.prototype.onToday = function (value) {
        value = moment().format("YYYY-MM-DD");
        return this.operand === value;
    };
    DateRecordFilter.prototype.before = function (value) {
        if (!value) {
            return false;
        }
        value = this.extractDate(value);
        return value.localeCompare(this.operand) == -1;
    };
    DateRecordFilter.prototype.onOrBefore = function (value) {
        if (!value) {
            return false;
        }
        value = this.extractDate(value);
        return value.localeCompare(this.operand) <= 0;
	};
	DateRecordFilter.prototype.onOrBeforeToday = function (value) {
        if (!value) {
            return false;
        }
        value = moment().format("YYYY-MM-DD");
        return value.localeCompare(this.operand) <= 0;
	};
	DateRecordFilter.prototype.beforeToday = function (value) {
        if (!value) {
            return false;
        }
        value = moment().format("YYYY-MM-DD");
        return value.localeCompare(this.operand) <= 0;
    };
    DateRecordFilter.prototype.after = function (value) {
        if (!value) {
            return false;
        }
        value = this.extractDate(value);
        return value.localeCompare(this.operand) == 1;
    };
    DateRecordFilter.prototype.onOrAfter = function (value) {
        if (!value) {
            return false;
        }
        value = this.extractDate(value);
        return value.localeCompare(this.operand) >= 0;
	};
	DateRecordFilter.prototype.onOrAfterToday = function (value) {
        if (!value) {
            return false;
        }
        value = moment().format("YYYY-MM-DD");
        return value.localeCompare(this.operand) >= 0;
	};
	DateRecordFilter.prototype.afterToday = function (value) {
        if (!value) {
            return false;
        }
        value = moment().format("YYYY-MM-DD");
        return value.localeCompare(this.operand) > 0;
    };
    DateRecordFilter.prototype.inQuarter = function (value) {
        if (!value) {
            return false;
        }
        value = this.extractDate(value);
        var quarter = parseInt(this.operand.substr(1, 1), 10);
        var year = this.operand.substr(3);

        var startDate, endDate;
        switch (quarter) {
            case 1:
                startDate = "01-01";
                endDate = "03-31";
                break;
            case 2:
                startDate = "04-01";
                endDate = "06-30";
                break;
            case 3:
                startDate = "07-01";
                endDate = "09-30";
                break;
            case 4:
            default:
                startDate = "10-01";
                endDate = "12-31";
        }

        startDate = year + "-" + startDate;
        endDate = year + "-" + endDate;

        return !(value.localeCompare(startDate) == -1 || value.localeCompare(endDate) == 1);
    };
    DateRecordFilter.prototype.inMonth = function (value) {
        if (!value) {
            return false;
        }
        value = this.extractDate(value);
        var month = this.operand.substr(0, 2);
        var year = this.operand.substr(3);

        var startDate, endDate;
        startDate = month + "-01";
        endDate = month + "-31";

        startDate = year + "-" + startDate;
        endDate = year + "-" + endDate;

        return !(value.localeCompare(startDate) == -1 || value.localeCompare(endDate) == 1);
    };
    DateRecordFilter.prototype.inYear = function (value) {
        if (!value) {
            return false;
        }
        value = this.extractDate(value);
        var year = this.operand;

        var startDate, endDate;
        startDate = "01-01";
        endDate = "12-31";

        startDate = year + "-" + startDate;
        endDate = year + "-" + endDate;

        return !(value.localeCompare(startDate) == -1 || value.localeCompare(endDate) == 1);
    };
    DateRecordFilter.prototype.today = function (value) {
        if(!value){
            return false;
        }
        value = this.extractDate(value);

        return value === moment().format("YYYY-MM-DD");
    };
    DateRecordFilter.prototype.tomorrow = function (value) {
        if(!value){
            return false;
        }
        value = this.extractDate(value);

        return value === moment().add(1,"days").format("YYYY-MM-DD");
    };
    DateRecordFilter.prototype.inThisWeek = function (value) {
        if(!value){
            return false;
        }
        value = this.extractDate(value);

        var lastSunday = moment().weekday(0).format("YYYY-MM-DD");
        var nextMonday = moment().weekday(8).format("YYYY-MM-DD");

        return moment(value).isBetween(lastSunday,nextMonday);
	};
	DateRecordFilter.prototype.inTheNextXDays = function (value) {
		if(!value){
            return false;
        }
		value = this.extractDate(value);

		var dateX = moment().add(this.operand + 1,'days');

		return moment(value).isBefore(dateX);
	};
	DateRecordFilter.prototype.currentMonth = function (value) {
        if (!value) {
            return false;
        }
        value = moment().format("YYYY-MM-DD");
        return value.isSame(this.operand, 'month');
	};
	DateRecordFilter.prototype.currentYear = function (value) {
        if (!value) {
            return false;
        }
        value = moment().format("YYYY-MM-DD");
        return value.isSame(this.operand, 'year');
	};
	DateRecordFilter.prototype.anniversary = function(value) {
		if(!value){
            return false;
        }
        if(typeof value == "object"){
            momentValue = moment(value.value).format("MM-DD");
        }

        return value === moment().format("MM-DD");
    };

	function DateTimeRecordFilter(json) {
		DateRecordFilter.call(this, json);
		this.registerPredicate('in the last 5 minutes', this.inTheLast5Minutes, {needOperand: false});
		this.registerPredicate('in the last 15 minutes', this.inTheLast15Minutes, {needOperand: false});
		this.registerPredicate('in the last hour', this.inTheLastHour, {needOperand: false});
	};

    createSubclass(RecordFilter, DateTimeRecordFilter);

    DateTimeRecordFilter.prototype.extractDate = function(value){
        if(!value) {
            return value;
        }

        if(typeof value == "object"){
            return moment(value.value).format("YYYY-MM-DD HH:mm");
        }
        return value.substr(0,16);
    };
    DateTimeRecordFilter.prototype.on = function (value) {
        return DateRecordFilter.prototype.on.call(this,this.extractDate(value));
    };
    DateTimeRecordFilter.prototype.before = function (value) {
        return DateRecordFilter.prototype.before.call(this,this.extractDate(value));
    };
    DateTimeRecordFilter.prototype.onOrBefore = function (value) {
        return DateRecordFilter.prototype.onOrBefore.call(this,this.extractDate(value));
    };
    DateTimeRecordFilter.prototype.after = function (value) {
        return DateRecordFilter.prototype.after.call(this,this.extractDate(value));
    };
    DateTimeRecordFilter.prototype.onOrAfter = function (value) {
        return DateRecordFilter.prototype.onOrAfter.call(this,this.extractDate(value));
    };
    DateTimeRecordFilter.prototype.inQuarter = function (value) {
        return DateRecordFilter.prototype.inQuarter.call(this,this.extractDate(value));
    };
    DateTimeRecordFilter.prototype.inMonth = function (value) {
       return DateRecordFilter.prototype.inMonth.call(this,this.extractDate(value));
    };
    DateTimeRecordFilter.prototype.inYear = function (value) {
        return DateRecordFilter.prototype.inYear.call(this,this.extractDate(value));
    };
    DateTimeRecordFilter.prototype.today = function (value){
        return DateRecordFilter.prototype.today.call(this,this.extractDate(value));
    };
    DateTimeRecordFilter.prototype.tomorrow = function (value){
        return DateRecordFilter.prototype.tomorrow.call(this,this.extractDate(value));
    };
    DateTimeRecordFilter.prototype.inThisWeek = function (value){
        return DateRecordFilter.prototype.inThisWeek.call(this,this.extractDate(value));
	};
	DateTimeRecordFilter.prototype.inTheNextXDays = function (value){
		return DateRecordFilter.prototype.inTheNextXDays.call(this,this.extractDate(value));
	};
	DateTimeRecordFilter.prototype.inTheLast5Minutes = function (value){
		if(!value){
            return false;
		}
		
		return moment(value).isBetween(moment().subtract(6,'minutes'),moment());
	};
	DateTimeRecordFilter.prototype.inTheLast15Minutes = function (value){
		if(!value){
            return false;
		}
		
		return moment(value).isBetween(moment().subtract(16,'minutes'),moment());
	};
	DateTimeRecordFilter.prototype.inTheLastHour = function (value){
		if(!value){
            return false;
		}
		
		return moment(value).isBetween(moment().subtract(61,'minutes'),moment());
	};

    function RecordFilterFactory() {
        return this;
    };


    RecordFilterFactory.createFilter = function (field) {
         var newFilter = (function(field){
            if (field.enumColors || field.condEnumColors) {
                return new EnumRecordFilter();
            }
            if (field.type == 'boolean') {
                return new BooleanRecordFilter();
            }
            if (field.type == 'date' && field.timeAndDate == 1) {
                return new DateTimeRecordFilter();
            }
            if (field.type == 'date') {
                return new DateRecordFilter();
            }

            if(field.type == 'lastmodified') {
                return new DateTimeRecordFilter();
            }

            if (field.type == 'int' || field.type == 'autonumber') {
                return new IntRecordFilter();
            }
            if (field.type == 'double') {
                return new FloatRecordFilter();
            }
            if (field.type == 'files') {
                return new FilesRecordFilter();
            }
            if (field.type == 'comments' || field.type == 'activity') {
                return new CommentsRecordFilter();
            }

            if(field.type == 'link' && field.link.category.sysFunc==SysFunc.MEMBERS) {
                return new UserLinksRecordFilter();
            }

    		if(field.type == 'link' || field.type == 'lookup') {
                var target = getLinkTargetField(field);
                var textLinks = {
                    shorttext: true,
                    mediumtext: true,
                    enumforeign: true
                };
                var hasTextTarget = textLinks[target.type] ||
                    (target.type=="formula" && target.formula && textLinks[target.formula.outputType]);
                return  hasTextTarget ? new TextLinksRecordFilter() : new LinksRecordFilter();
    		}

            if(field.type== 'formula') {
                return RecordFilterFactory.createFilter($.extend({},field,{type: field.formula.outputType}));
            }

            return new TextRecordFilter();
        })(field);
        newFilter.id = generateTmpFilterId();

        return newFilter;
    };

    class RecordFilterGroup {
        constructor (json) {
            this.byIndex = [];
            this.byId = {};
            this.operator = "and";
    
            if (json) {
                this.fromJson(json);
            }    
        }
        getFieldId (index) {
            return this.byIndex[index].id;
        }
        indexOf (recordFilter) {
            for (var i = 0; i < this.byIndex.length; i++) {
                if (this.byIndex[i].filter === recordFilter) {
                    return i;
                }
            }
            return -1;
        }
        setAt (index, recordFilter, field_id) {
            if (!field_id) {
                field_id = this.byIndex[index].id;
            }
            field_id += '';

            this.removeInById(this.byIndex[index]);

            this.byIndex[index] = {
                filter: recordFilter,
                id: field_id
            };
            this.addInById(recordFilter, field_id);

        }
        setOperator (operator) {
            this.operator = operator;
        }
        getOperator () {
            return this.operator;
        }

        /**
         * Usages: 
         * getReadyFilterCount()
         * getReadyFilterCount(start)
         * getReadyFilterCount(start,stop)
         * getReadyFilterCount(start,stop,predicate)
         * getReadyFilterCount(predicate)
         */
        getReadyFilterCount () {
            switch(arguments.length) {
                case 0:
                    return this.getReadyFilterCountUtil();
                case 1:
                    return $.isFunction(arguments[0]) ? 
                        this.getReadyFilterCountUtil(null,null,arguments[0]) :
                        this.getReadyFilterCountUtil(arguments[0]);
                case 2:
                    return this.getReadyFilterCountUtil(arguments[0],arguments[1]);
                case 3:
                default:
                    return this.getReadyFilterCountUtil(arguments[0],arguments[1],arguments[2]);
            }
            
        }
        getReadyFilterCountUtil (start, stop, predicate) {
            var count = 0;
            if (start === null || start === undefined) {
                start = 0;
            }
            if (stop === null || stop === undefined) {
                stop = this.byIndex.length;
            }
            for (var i = start; i < stop; i++) {
                if (this.byIndex[i].filter.isReady() && (!predicate || predicate(this.byIndex[i].filter)) ) {
                    count++;
                }
            }
            return count;
        }
        hasSort() {
            var predicates = {
                "bottom": true,
                "top": true
            };

            return find(function(byIndex) {
                var filter = byIndex.filter;
                return filter.isReady() && (filter instanceof RecordGroupBy || predicates[filter.predicateString]);
            },this.byIndex) ? true : false;
        }
        removeAt (index) {
            this.removeInById(this.byIndex[index]);
            this.byIndex.splice(index, 1);
        }
        push (recordFilter, field_id) {
            field_id = field_id + '';
            this.byIndex.push({
                filter: recordFilter,
                id: field_id
            });
            this.addInById(recordFilter, field_id);
        }
        insertAt (index, recordFilter, field_id) {
            this.byIndex.splice(index,0,{
                filter: recordFilter,
                id: field_id
            });
            this.addInById(recordFilter, field_id);
        }
        at (index) {
            return this.byIndex[index].filter;
        }
        length () {
            return this.byIndex.length;
        }
        /**
         * filter the rows of fields
         * @param  {array} fields      The fields
         * @param  {object} neededInfos Additionnal informations needed by filters.
         * Format is {utilisateur_code: <utilisateur_code>}
         * @return {array}             array of filtered row indexes
         */
        filterRows (fields,neededInfos) {
            var result, i;
            result = [];
            if (!fields.length || !fields[0].values || !fields[0].values.length) {
                return result;
            }
            var gbInfos = this.getGroupByInfos(fields);
            var filterInfos = this.getFilterInfos(fields);

            if (gbInfos.length) {
                var groups = this.groupBy(fields, gbInfos);
                if (gbInfos.length == this.byIndex.length) {
                    return this.flattenGroups(groups);
                }
                var accCount = this.countFiltersWithAcc();
                var stop = accCount > 1 ? this.firstFilterWithAcc(gbInfos.length) : null;
                for (i = 0; i < groups.length; i++) {
                    groups[i] = this.runFilters(fields, filterInfos, groups[i], gbInfos.length, stop, neededInfos);
                }
                result = this.flattenGroups(groups);
                if (accCount <= 1) {
                    return result;
                }
                return this.runFilters(fields, filterInfos, result, this.firstFilterWithAcc(stop + 1),null, neededInfos);
            }

            //initial result (before filtering) is all row indexes
            for (i = 0; i < fields[0].values.length; i++) {
                result.push(i);
            }
            return this.runFilters(fields, filterInfos, result, 0, null, neededInfos);
        }
        flattenGroups (groups) {
            var result = [];
            return result.concat.apply(result, groups);
        }
        runFilters (fields, filterInfos, rowIndexes, start, stop, neededInfos) {
            if (stop === undefined || stop === null) {
                stop = this.firstFilterWithAcc(start);
                if (stop == -1) {
                    stop = this.byIndex.length;
                }
            }

            var result = [];
            var readyCount = this.getReadyFilterCount(start, stop);
            for (var i = 0; i < rowIndexes.length; i++) {
                if (!readyCount || this.testRow(fields, filterInfos, rowIndexes[i], start, stop, neededInfos)) {
                    result.push(rowIndexes[i]);
                }
            }

            if (stop == this.byIndex.length || !result.length) {
                return result;
            }
            var accResult = this.runAccumulator(fields, result, this.byIndex[stop].id, this.byIndex[stop].filter, neededInfos);
            if (!accResult.length) {
                return [];
            }

            result = accResult;
            if ((stop + 1) == this.byIndex.length) {
                return result;
            }

            return this.runFilters(fields, filterInfos, result, stop + 1,null, neededInfos);
        }
        runAccumulator (fields, rowIndexes, field_id, accFilter, neededInfos) {
            var acc = {};
            var field_index = findIndexById(fields, field_id);
            var results = [];

            if(accFilter.operandNeedFieldId() && accFilter.getOperand().field_id) {
                var operandFieldIndex = findIndexById(fields, accFilter.getOperand().field_id);
                if(operandFieldIndex!=-1) {
                    var fieldWithValue = fieldProp(fields[operandFieldIndex]);
                    for (var i = 0; i < rowIndexes.length; i++) {
                        fieldWithValue.value = fields[operandFieldIndex].values[rowIndexes[i]].value;
                        accFilter.runAccumulator(fields[field_index].values[rowIndexes[i]].value, acc, rowIndexes[i], results,
                            $.extend({},neededInfos,{operandTextFieldValue: valueAsText(fieldWithValue,{fileDisplay: "urls"})} ) );
                    }
                    return results;
                }
            }

            for (var i = 0; i < rowIndexes.length; i++) {
                accFilter.runAccumulator(fields[field_index].values[rowIndexes[i]].value, acc, rowIndexes[i], results,neededInfos);
            }

            return results;
        }
        firstFilterWithAcc (startIndex) {
            for (var i = startIndex; i < this.byIndex.length; i++) {
                if (!(this.byIndex[i].filter instanceof RecordGroupBy) &&
                    this.byIndex[i].filter.needAccumulator() && this.byIndex[i].filter.isReady()) {
                    return i;
                }
            }
            return -1;
        }
        countFiltersWithAcc () {
            var count = 0;
            for (var i = 0; i < this.byIndex.length; i++) {
                if (!(this.byIndex[i].filter instanceof RecordGroupBy) &&
                    this.byIndex[i].filter.needAccumulator() && this.byIndex[i].filter.isReady()) {
                    count++;
                }
            }
            return count;
        }
        groupBy (fields, gbInfos) {
            var self = this;
            var valueToIndex = {};
            var result = [];
            var field = fields[gbInfos[0].field_index];

            for (var i = 0; i < field.values.length; i++) {
                this.pushGroupedValue(result, i, field, field.values[i].value, valueToIndex);
            }
            result = this.sortGroup(field,gbInfos[0].asc,result);
            if (gbInfos.length == 1) {
                return result;
            }

            for (i = 1; i < gbInfos.length; i++) {
                var newResult = [];
                for (var j = 0; j < result.length; j++) {
                    newResult = newResult.concat(this.subGroupBy(result[j], fields[gbInfos[i].field_index], gbInfos[i].asc) );

                }
                result = newResult;
            }

            return result;
        }
        subGroupBy (group, field, asc) {
            var result = [];
            var valueToIndex = {};
            for (var i = 0; i < group.length; i++) {
                this.pushGroupedValue(result, group[i], field,field.values[group[i]].value, valueToIndex);
            }
            return this.sortGroup(field,asc,result);
        }

        sortGroup(field,asc,groupByResult) {

            var compareEmpty = function(compare,a,b) {
                if(a==='' && b==='') {
                    return 0;
                }
                if(a==='') {
                    return 1;
                }
                if(b==='') {
                    return -1;
                }
                return compare(a,b);
            };

            var reverseCompare = function(compare,a,b) {
                return compare(a,b)*-1;
            };

            var resolvedType = (field.type=='formula' && field.formula.outputType) || field.type;

            var compare = this.getTypeCompareFunction(resolvedType);
            if(!asc) {
                compare = reverseCompare.bind(null,compare);
            }
            if(resolvedType!=='boolean') {
                compare = compareEmpty.bind(null,compare);
            }

            groupByResult.sort(function(a,b) {
                return compare(a.textValue,b.textValue);
            });
            return groupByResult.map(function(group) {
                return group.rowIndexes;
            });
        }

        getTypeCompareFunction (resolvedType) {

            var compareNumber = function(a,b) {
                var parsedA = numeral().unformat(a);
                var parsedB = numeral().unformat(b);

                var invalidA = parsedA===null || isNaN(parsedA);
                var invalidB = parsedB===null || isNaN(parsedB);
                if(invalidA && invalidB) {
                    return 0;
                }
                if(invalidA) {
                    return 1;
                }
                if(invalidB) {
                    return -1;
                }

                return parsedA - parsedB;
            };

            var compareBoolean = function(a,b) {
                if(a===b) {
                    return 0;
                }

                return a==='checked' ? 1 : -1;
            };

            var noCaseCompare = function(a,b) {
                return (a + '').toLowerCase().localeCompare((b + '').toLowerCase());
            };

            var isNumeric = {
                'int' : true,
                'double' : true,
                'autonumber' : true
            };

            if(isNumeric[resolvedType]) {
                return compareNumber;
            }
            if(resolvedType==='boolean') {
                return compareBoolean;
            }
            return noCaseCompare;
        }

        pushGroupedValue (result, rowIndex, field,value, valueToIndex) {
            var fieldWithValue = $.extend({},field,{value: value});
            var textValue = valueAsText(fieldWithValue,{
                linkSeparator: "/-/",
                fileDisplay: "name"
            });

            textValue = textValue.replace(/ /g, '');

            var index = valueToIndex.hasOwnProperty(textValue) ? valueToIndex[textValue] : -1;
            if (index === -1) {
                valueToIndex[textValue] = index = result.length;
                result.push({textValue: textValue,rowIndexes: []});
            }
            result[index].rowIndexes.push(rowIndex);
        }
        getGroupByInfos (fields) {
            var result = [];
            for (var i = 0; i < this.byIndex.length; i++) {
                if (!(this.byIndex[i].filter instanceof RecordGroupBy)) {
                    break;
                }
                result.push({
                    field_id: this.byIndex[i].id,
                    field_index: findIndexById(fields, this.byIndex[i].id),
                    asc: this.byIndex[i].filter.predicateString==="asc"
                });
            }
            return result;
        }
        getFilterInfos (fields) {
            var result = [];
            for (var i = 0; i < this.byIndex.length; i++) {
                result.push({
                    field_id: this.byIndex[i].id, field_index: findIndexById(fields, this.byIndex[i].id),
                    filter: this.byIndex[i].filter
                });
            }
            return result;
        }
        countGroupBy () {
            var count = 0;
            for (var i = 0; i < this.byIndex.length; i++) {
                if (this.byIndex[i].filter instanceof RecordGroupBy) {
                    count++;
                } else {
                    break;
                }
            }
            return count;
        }
        testRow (fields, filterInfos, rowIndex, start, stop, neededInfos) {
            var i;
            start = start || 0;
            stop = stop || this.byIndex.length;
            if (stop <= start || stop > filterInfos.length) {
                return true;
			}

			for (i = start; i < filterInfos.length && i < stop; i++) {
				if (filterInfos[i].filter.isReady()) {
					if (undefined == fields[filterInfos[i].field_index]) {
						return true;	// If one of the fields is restricted, the value cannot be read, show the row.
					}
					if ('and' == this.operator && !filterInfos[i].filter.test(fields[filterInfos[i].field_index].values[rowIndex].value, neededInfos)) {
						return false;	// 'and' => As soon as a test is false, return false
					}
					else if ('or' == this.operator && filterInfos[i].filter.test(fields[filterInfos[i].field_index].values[rowIndex].value, neededInfos)) {
						return true;	// 'or' => As soon as a test is true, return true
					}
				}
			}
            return ('and' == this.operator);
        }
        addInById (recordFilter, field_id) {
            if (!this.byId[field_id]) {
                this.byId[field_id] = [];
            }
            this.byId[field_id].push(recordFilter);
        }
        removeInById (filterItem) {
            for (var i = 0; i < this.byId[filterItem.id].length; i++) {
                if (this.byId[filterItem.id][i] == filterItem.filter) {
                    this.byId[filterItem.id].splice(i, 1);
                    if (!this.byId[filterItem.id].length) {
                        delete this.byId[filterItem.id];
                    }
                    break;
                }
            }
        }
        toString () {
            var byId = this.byId;
            var s = "RecordFilterGroup: ";
            Object.keys(byId).forEach(function (key) {
                s += "[";
                for (var i = 0; i < byId[key].length; i++) {
                    s += "(" + byId[key][i].toString() + ") ";
                }
                s += "] ";
            });
            return s;
        }
        fromJson (json) {
            this.operator = json.operator;
            this.byIndex = [];
            this.byId = {};
            for (var i = 0; i < json.filters.length; i++) {
                var filter = json.filters[i];
                var recordFilter;
                if (filter.filter_type == 'int') {
                    recordFilter = new IntRecordFilter(filter.json);
                } else if (filter.filter_type == 'float') {
                    recordFilter = new FloatRecordFilter(filter.json);
                } else if (filter.filter_type == 'date') {
                    recordFilter = new DateRecordFilter(filter.json);
                } else if (filter.filter_type == 'datetime' ) {
                    recordFilter = new DateTimeRecordFilter(filter.json);
                }else if (filter.filter_type == 'enum') {
                    recordFilter = new EnumRecordFilter(filter.json);
                } else if (filter.filter_type == 'boolean') {
                    recordFilter = new BooleanRecordFilter(filter.json);
                } else if (filter.filter_type == 'groupby') {
                    recordFilter = new RecordGroupBy(filter.json);
                } else if (filter.filter_type == 'files') {
                    recordFilter = new FilesRecordFilter(filter.json);
                } else if (filter.filter_type == 'userLink') {
                    recordFilter = new UserLinksRecordFilter(filter.json);
		        } else if (filter.filter_type == 'textLink') {
                    recordFilter = new TextLinksRecordFilter(filter.json);
		        } else if (filter.filter_type == 'link' || filter.filter_type == 'lookup') {
		          recordFilter = new LinksRecordFilter(filter.json);
                } else if (filter.filter_type == 'comments' || filter.filter_type == 'activity') {
                    recordFilter = new CommentsRecordFilter(filter.json);
                } else {
                    recordFilter = new TextRecordFilter(filter.json);
                }
                recordFilter.id = filter.id;
                this.push(recordFilter, filter.field_id);
            }
        }
        toJson () {
            var json = {
                operator: this.operator,
                filters: []
            };
            for (var i = 0; i < this.byIndex.length; i++) {
                var filter = this.byIndex[i].filter;
                var filter_type = '';
                if (filter instanceof IntRecordFilter) {
                    filter_type = 'int';
                } else if (filter instanceof FloatRecordFilter) {
                    filter_type = 'float';
                } else if (filter instanceof DateTimeRecordFilter) {
                    filter_type = 'datetime';
                } else if (filter instanceof DateRecordFilter) {
                    filter_type = 'date';
                } else if (filter instanceof EnumRecordFilter) {
                    filter_type = 'enum';
                } else if (filter instanceof BooleanRecordFilter) {
                    filter_type = 'boolean';
                } else if (filter instanceof RecordGroupBy) {
                    filter_type = 'groupby';
                } else if (filter instanceof FilesRecordFilter) {
                    filter_type = 'files';
				} else if(filter instanceof UserLinksRecordFilter) {
                    filter_type = 'userLink';
                } else if(filter instanceof TextLinksRecordFilter) {
                    filter_type = 'textLink';
                } else if(filter instanceof LinksRecordFilter) {
					filter_type = 'link';
                } else if (filter instanceof CommentsRecordFilter) {
                    filter_type = 'comments';
                } else {
                    filter_type = 'text';
                }
                json.filters.push({
                    id: filter.id,
                    json: filter.toJson(),
                    field_id: this.byIndex[i].id,
                    filter_type: filter_type
                });
            }

            return json;
        }
        reorderFilters(newIds){
            var recordFilterToJson = this.toJson();
            var jsonFilters = $.extend([],recordFilterToJson.filters);
            this.byIndex = [];
            this.byId = {};

            var reorderedFilters = [];
            for(var i=0;i<newIds.length;i++){
                var filteredFilter = jsonFilters.filter(function(filterRow){
                    return filterRow.id == newIds[i];
                });
                reorderedFilters.push(filteredFilter[0]);
            }
            recordFilterToJson.filters = reorderedFilters;
            this.fromJson(recordFilterToJson);
        }
        toDefaultValues() {
            var field_id,filter,i,defaultValues={};
            for(field_id in this.byId) {
                if(!this.byId.hasOwnProperty(field_id)) {
                    continue;
                }
                filter = find(isLinkIs,this.byId[field_id]);
                if(filter) {
                    defaultValues[field_id] = Array.isArray(filter.getOperand())?filter.getOperand()[0]:filter.getOperand();
                }
            }
            
            return defaultValues;

            // functions
            function isLinkIs(filter) {
                return (filter instanceof TextRecordFilter  && filter.isReady() && filter.getPredicate() === "is")
                || (filter instanceof LinksRecordFilter  && filter.isReady() && filter.getPredicate() === "is")
                || (filter instanceof EnumRecordFilter  && filter.isReady() && filter.getPredicate() === "is any of")
                || (filter instanceof IntRecordFilter  && filter.isReady() && filter.getPredicate() === "equals")
                || (filter instanceof FloatRecordFilter  && filter.isReady() && filter.getPredicate() === "equals")
                || (filter instanceof DateRecordFilter  && filter.isReady() && filter.getPredicate() === "on");
            }
        }
    };


    /**
     * @param position {top,left}
     * @param fields source category fields
     * @param {RecordFilterGroup} filterGroup
     * @param {boolean} filtersSaved initial value indicating weither filter are saved or nor
     * @param {boolean} enableFilterOnKeyUp If true refilter will be called when a filter change
     * occurs on key up (with a timeout)
     * @param callbacks {
     *        refilter : function(onDone),
     *        filterCountChange: function(readyCount),
     *        filtersChanged: function(filterGroup),
	 *        applyFilters: function(onDoneCallback)
	 *        saveFilters: function(onDoneCallback),
     *        onClose:function($simplePopup)
     * }
     */
    function displayFilterDialog(options) {

        var defaults = {
            position: null,
            fields: [],
            filterGroup: null,
            dateFormat: defaultDateFormat.data,
            filtersSaved: true,
            enableFilterOnKeyUp: true,
            callbacks: {
                refilter : function(onDone) { onDone && onDone();},
                filterCountChange: function(readyCount) {},
				filtersChanged: function(filterGroup) {},
				applyFilters: function(onDoneCallback) {},
                saveFilters: function(onDoneCallback) {},
                onClose:function($simplePopup) { }
            },
			displaySaveFilters: true,
			displayGroupBy: true,
			conditionalVisibility: false,
        },
        options = $.extend(defaults,options),
        position = options.position,
        fields = options.fields,
        filterGroup = options.filterGroup,
        dateFormat = options.dateFormat,
        filtersSaved = options.filtersSaved,
        callbacks = options.callbacks;

        function FilterInputType() {
            return this;
        };

        FilterInputType.EMPTY = 1;
        FilterInputType.BOOLEAN = 2;
        FilterInputType.DATE = 3;
        FilterInputType.DATE_QUARTER = 4;
        FilterInputType.ENUM = 5;
        FilterInputType.TEXT = 6;
        FilterInputType.TEXT_AUTOCOMPLETE = 7;
        FilterInputType.ACCUMULATOR_WITH_OPERAND = 8;
        FilterInputType.DATE_MONTH = 10;
		FilterInputType.DATE_YEAR = 11;
        FilterInputType.LINKSELECT = 12;

        var saveFiltersDisabled = filtersSaved ? 'disabled="disabled"'  : '';
        var html =
            "<h3  class='popupLeftTitle' style='margin:0'>"+
            "<span class='glyphicon glyphicon-filter'></span>"+
            "<span class='recordFilterTitle'></span>"+
            "<img class='loading' src='/images/loadingImg.gif' style='display: none;'>" +
			"</h3>" +
			(options.displayGroupBy ?
				'<table class="filterTable groupByRows"><tbody></tbody></table> ' +
            	'<input type="button" name="addGroupBy" class="cmdButton blueGrad noSelect" value="' + TLang['Add group by'] + '"></input>' : '') +
            '<table class="filterTable filterRows"><tbody></tbody></table> ' +
            '<input type="button" name="addFilter" class="cmdButton blueGrad noSelect" value="' + TLang['Add filter'] + '"></input><br /><br />' +
            '<input type="button" name="cancel" class="cmdButton blueGrad noSelect" value="' + TLang['Cancel'] + '"></input>'+
            '<input type="button" name="applyFilters" class="cmdButton blueGrad noSelect" '+saveFiltersDisabled+' value="' + TLang['Apply'] + '"></input>'+
            (options.displaySaveFilters ? 
                '<input type="button" name="saveFilters" class="cmdButton blueGrad noSelect" '+saveFiltersDisabled+' value="' + TLang['Save with view'] + '"></input>' :
                '');

        var $saveFilters=null;
        var $applyFilters=null;

        var triggerFiltersChanged = function() {
            if(!$saveFilters) {
                $saveFilters = $simplePopup.find('input[name="saveFilters"]');
            }
            if(!$applyFilters) {
            	$applyFilters = $simplePopup.find('input[name="applyFilters"]');
            }
            $applyFilters.prop('disabled',false);
            $saveFilters.prop('disabled',false);
            if(callbacks.filtersChanged) {
                callbacks.filtersChanged(filterGroup);
            }
        };


        var $simplePopup = showSimplePopup(html, position.left, position.top, "fpCommonPopup recordFilterPopup", function ($popup) {
            $simplePopup = $popup;
            $grayOutBox.addClass("clearBackg");

            var $groupByTable = $simplePopup.find('.groupByRows');
            var $filterTable = $simplePopup.find('.filterRows');

            $simplePopup.find('input[name="addFilter"]').click(function () {
                var recordFilter = RecordFilterFactory.createFilter(fields[0]);
                filterGroup.push(recordFilter, fields[0].id);
                appendFilterRow($filterTable, fields, recordFilter, filterGroup);

                //re-generate row prefixes
                var $firstCells = $filterTable.find('tr.filterRow > td:nth-child(2)');
                for (var i = 0; i < $firstCells.length; i++) {
                    $firstCells.eq(i).empty().append(
                        createRowPrefix($filterTable, fields, filterGroup, filterGroup.countGroupBy() + i)
                    );
                }

                triggerFiltersChanged();
            });

            $simplePopup.find('input[name="addGroupBy"]').click(function () {
                var recordFilter = new RecordGroupBy();
                recordFilter.id = generateTmpFilterId();
                var fieldIndex = findNextFieldIndexForGroupBy(filterGroup,fields);
                filterGroup.insertAt(filterGroup.countGroupBy(),recordFilter, fields[fieldIndex].id);
                appendFilterRow($groupByTable, fields, recordFilter, filterGroup);

                setRecordFilterCount();
                triggerFiltersChanged();
                refilter();
            });

            var $saveFilters = $simplePopup.find('input[name="saveFilters"]');
            var $applyFilters = $simplePopup.find('input[name="applyFilters"]');
            var onFiltersSaved = function() {
                $applyFilters.prop('disabled',true);
                $saveFilters.prop('disabled',true);
            };
            $saveFilters.click(function () {
                if(callbacks.saveFilters) {
                    callbacks.saveFilters(onFiltersSaved);
                }
                $simplePopup.close();
            });

            $applyFilters.click(function () {
				if(callbacks.applyFilters) {
                    callbacks.applyFilters(onFiltersSaved);
                }
                $simplePopup.close();
            });
            var $cancel = $simplePopup.find('input[name="cancel"]');
            $cancel.click(function () {
                $simplePopup.close();
            });

            $simplePopup.find('input[name="newName"]').focus();

            var initRows = initFilterRows.bind(null,$groupByTable,$filterTable,filterGroup,fields);
            initRows();
            var onSortableUpdate = function(event,ui){
                var reorderedGroupBys = $groupByTable.find("> tbody").sortable("toArray",{"attribute":"id"});
                var reorderedFilters = $filterTable.find("> tbody").sortable("toArray",{"attribute":"id"});
                filterGroup.reorderFilters(reorderedGroupBys.concat(reorderedFilters));

                //Re-generate filter list in order to update values
                $groupByTable.find("> tbody").empty();
                $filterTable.find("> tbody").empty();
                initRows();

                triggerFiltersChanged();
                refilter();
            };
            enableSortable($groupByTable,onSortableUpdate);
            enableSortable($filterTable,onSortableUpdate);

            setRecordFilterCount();

        }, function ($simplePopup) {
            $grayOutBox.removeClass("clearBackg");
            if (callbacks.onClose != undefined && callbacks.onClose != null) {
                callbacks.onClose($simplePopup);
            }
        });

        function initFilterRows($groupByTable,$filterTable,filterGroup,fields) {
            var i,recordFilter;
            for (i = 0; i < filterGroup.countGroupBy(); i++) {
                recordFilter = filterGroup.at(i);
                appendFilterRow($groupByTable, fields, recordFilter, filterGroup);
            }

            for (; i < filterGroup.length(); i++) {
                recordFilter = filterGroup.at(i);
                appendFilterRow($filterTable, fields, recordFilter, filterGroup);
            }
        };

        function findNextFieldIndexForGroupBy(filterGroup,fields) {
            var count = filterGroup.countGroupBy(),max=0;
            if(count==0) {
                return 0;
            }
            for(var i=0;i<count;i++) {
                var field_id = filterGroup.getFieldId(i);
                var index = findIndexById(fields,field_id);
                if(index > max) {
                    max = index;
                }
            }
            if(max+1 == fields.length) {
                return max;
            }
            return max + 1;
        };

        function onRefilterDone() {
            $simplePopup.find('.loading').css('display','none');
        };

        function refilter() {
            $simplePopup.find('.loading').css('display','inline');
            callbacks.refilter(onRefilterDone);
        };



        function enableSortable($table,onUpdate){
            $table.find("> tbody").sortable({
                handle: ".ion-drag",
                delay: 150,
                update: onUpdate
            });
        };



        function findCategoryById(categories, cat_id) {
            for (var i = 0; i < categories.length; i++) {
                if (categories[i].id == cat_id) {
                    return categories[i];
                }
            }
            return null;
        };


        function setRecordFilterCount() {
			if (!options.title) {
				var count = 0;
				if (filterGroup) {
					count = filterGroup.getReadyFilterCount();
				}
				if (count) {
					var filterPlural;
					if (count > 1) {
						filterPlural = TLang['Filter-s'];
					} else {
						filterPlural = TLang['Filter-u'];
					}
					$simplePopup.find('.recordFilterTitle').text(count + ' ' + filterPlural);
					$simplePopup.addClass('hasFilters');
				} else {
					$simplePopup.find('.recordFilterTitle').text(TLang['Add filters']);
					$simplePopup.removeClass('hasFilters');
				}
				callbacks.filterCountChange(filterGroup.getReadyFilterCount());
			}
            else {
				$simplePopup.find('.recordFilterTitle').text(options.title);
				$simplePopup.addClass('hasFilters');
			}
        };

        function onChangeOperand(recordFilter, operand) {
            var start = Date.now();
            recordFilter.setOperand(operand);
            setRecordFilterCount();
            triggerFiltersChanged();
            refilter();
        };

        function convertToDatePickerFormat(format) {
            format = format.toLowerCase();
            return format.replace('yyyy', 'yy');
        };

        function arrayValuesToMap(a) {
            var result = {};
            for (var i = 0; i < a.length; i++) {
                result[a[i] + ''] = true;
            }
            return result;
        };


        function getFilterInputType(recordFilter, field) {
            if (!recordFilter.needOperand()) {
                return FilterInputType.EMPTY;
            }

            if (recordFilter.needAccumulator()) {
                return FilterInputType.ACCUMULATOR_WITH_OPERAND;
            }

            if (recordFilter instanceof BooleanRecordFilter) {
                return FilterInputType.BOOLEAN;
            }


            if (recordFilter instanceof DateTimeRecordFilter || recordFilter instanceof DateRecordFilter) {
                if (recordFilter.getPredicate() == 'in quarter') {
                    return FilterInputType.DATE_QUARTER;
                }
                else if (recordFilter.getPredicate() == 'in month') {
                    return FilterInputType.DATE_MONTH;
                }
                else if (recordFilter.getPredicate() == 'in year') {
                    return FilterInputType.DATE_YEAR;
				}
				else if (recordFilter.getPredicate() == 'in the next x days'){
					return FilterInputType.TEXT;
				}
                return FilterInputType.DATE;
            }
	
			if (recordFilter instanceof EnumRecordFilter && recordFilter.getPredicate() != "contains" && recordFilter.getPredicate() != "does not contain") {
				return FilterInputType.ENUM;
			}

			if ((recordFilter instanceof LinksRecordFilter || recordFilter instanceof TextLinksRecordFilter) 
				&& (recordFilter.getPredicate() == "is any of" || recordFilter.getPredicate() == "is not any of")){
				return FilterInputType.LINKSELECT;
			}

            if ((recordFilter instanceof LinksRecordFilter || recordFilter instanceof TextLinksRecordFilter) 
                && (recordFilter.getPredicate() == "is" || recordFilter.getPredicate() == "is not")){
                return FilterInputType.TEXT_AUTOCOMPLETE;
            }

            return FilterInputType.TEXT;
        };

        function createQuarterSelect(selected) {
            var value,text;
            var now = new Date();
            var year = now.getFullYear();
            var quarter = 4;
            year++;
            var stopYear = year - 15;

            var $select = $('<select>');
            $select.append('<option value=""></option>');
            for (; year >= stopYear; year--) {
                for (; quarter > 0; quarter--) {
                    text = TLang['Quarter-i'] + quarter + '-' + year;
                    value = 'Q' + quarter + '-' + year;
                    $select.append($('<option value="' + value + '">' + text + '</option>').prop('selected', selected === value));
                }
                quarter = 4;
            }

            return $select;
        };

        function createMonthSelect(selected) {
            var value;
            var now = new Date();
            var year = now.getFullYear();
            var month = 12;
            year++;
            var stopYear = year - 5;

            var $select = $('<select>');
            $select.append('<option value=""></option>');
            for (; year >= stopYear; year--) {
                for (; month > 0; month--) {
                    var smonth = month >= 10 ? month : '0' + month;
                    value = smonth + '-' + year;
                    $select.append($('<option value="' + value + '">' + value + '</option>').prop('selected', selected === value));
                }
                month = 12;
            }
            return $select;
        };

        function createYearSelect(selected) {
            var value;
            var now = new Date();
            var year = now.getFullYear();
            year = year + 5;
            var stopYear = 1900;

            var $select = $('<select>');
            $select.append('<option value=""></option>');
            for (; year >= stopYear; year--) {
                value = year.toString();
                $select.append($('<option value="' + value + '">' + value + '</option>').prop('selected', selected === value));
            }
            return $select;
        };

        function createFilterInput(recordFilter, field, fields) {

            if (recordFilter instanceof RecordGroupBy) {
                return $('<div></div>');
            }
            var $elem;
            var inputType = getFilterInputType(recordFilter, field);

            if (inputType == FilterInputType.EMPTY) {
                $elem = $('<input type="text" class="empty" disabled></input>');
            } else if (inputType == FilterInputType.BOOLEAN) {
                $elem = $('<input type="checkbox"></input>');
                if (recordFilter.getOperand() !== null) {
                    $elem.prop('checked', recordFilter.getOperand() == 1);
                }
                $elem.change(function () {
                    onChangeOperand(recordFilter, $elem.prop('checked') ? 1 : 0);
                });
            } else if (inputType == FilterInputType.DATE) {
                $elem = $('<input type="text"></input>');
                $elem.datepicker({
                    dateFormat: convertToDatePickerFormat(dateFormat)
                });
				if (recordFilter.getOperand()) {
					$elem.val(recordFilter.getOperand());
				}
                $elem.change(function () {
                    var val = $elem.val();
                    if (!moment(val, dateFormat, true).isValid()) {
                        val = null;
                        $elem.addClass('error');
                    } else {
                        $elem.removeClass('error');
                    }
                    onChangeOperand(recordFilter, val);
                });
            } else if (inputType == FilterInputType.DATE_QUARTER) {
                $elem = createQuarterSelect(recordFilter.getOperand());
                $elem.change(function () {
                    onChangeOperand(recordFilter, $elem.val() || null);
                });

            } else if (inputType == FilterInputType.DATE_MONTH) {
                $elem = createMonthSelect(recordFilter.getOperand());
                $elem.change(function () {
                    onChangeOperand(recordFilter, $elem.val() || null);
                });

            } else if (inputType == FilterInputType.DATE_YEAR) {
                $elem = createYearSelect(recordFilter.getOperand());
                $elem.change(function () {
                    onChangeOperand(recordFilter, $elem.val() || null);
                });

            } else if (inputType == FilterInputType.ENUM) {
                var enumOptions = [];
                var selectedMap = recordFilter.getOperand() ? arrayValuesToMap(recordFilter.getOperand()) : {};

                if(field.enumColors) {
                    enumOptions = field.enumColors.values.map(
                        enumColorValueToOption.bind(field.enumColors.displayColors,true,selectedMap)
                    );
                }else if(field.condEnumColors) {
                    enumOptions = mergeCondEnumColors(field.condEnumColors).map(
                        enumColorValueToOption.bind(null,true,selectedMap)
                    );
				}

				$elem = multipleSelect({
					options: enumOptions,
					onChange: function (selected) {
						if (!selected.length) {
							selected = null;
						}
						onChangeOperand(recordFilter, selected);
					}
				});
			} else if (inputType == FilterInputType.LINKSELECT){
				$elem = $("<div><img src='/images/loadingImg.gif'></img></div>");
				var selectedMap = recordFilter.getOperand() ? arrayValuesToMap(recordFilter.getOperand()) : {};
				var generateLinkFilterSelect = function(values, bTooMuchResults){
					$elem.empty();
					$elem.append(multipleSelect({
						options: values,
						onChange: function (selected) {
							if (!selected.length) {
								selected = null;
							}
							onChangeOperand(recordFilter, selected);
						}
					}));
					if (bTooMuchResults) {
						$elem.append('<span>' + TLang['Too much rows in filter'] + '</span>');
					}
				};
				getLinkSelectValues(field, selectedMap, generateLinkFilterSelect);
			} else if (inputType == FilterInputType.TEXT || inputType == FilterInputType.TEXT_AUTOCOMPLETE) {
                function onChange() {
                    if (changeTimeout != null) {
                        clearTimeout(changeTimeout);
                        changeTimeout = null;
                    }
                    var val = $elem.val();
                    if (val == oldVal) {
                        return;
                    }
                    oldVal = val;
                    if (val == '') {
                        onChangeOperand(recordFilter, null);
                        return;
                    }
                    if (recordFilter instanceof IntRecordFilter) {
                        val = parseInt(val, 10);
                    }
                    else if (recordFilter instanceof FloatRecordFilter) {
                        val = parseFloat(val);
                    }
                    if (recordFilter instanceof IntRecordFilter || recordFilter instanceof FloatRecordFilter) {
                        if (isNaN(val)) {
                            $elem.addClass('error');
                            onChangeOperand(recordFilter, null);
                            return;
                        }

                        $elem.removeClass('error');

                    }
                    onChangeOperand(recordFilter, val);
                }

                $elem = $('<input type="text"></input>');

                if (inputType == FilterInputType.TEXT_AUTOCOMPLETE) {
                    if(recordFilter instanceof LinksRecordFilter) {
                        generateLinkFilterAutocomplete($elem,field,onChange);
                    }else if(field.enumColors) {
                        generateEnumAutocomplete($elem,field.enumColors,onChange);
                    }
                }
                if (recordFilter.getOperand() !== null) {
                    $elem.val(recordFilter.getOperand());
                }

                var oldVal = $elem.val();

                var changeTimeout = null;
                options.enableFilterOnKeyUp && $elem.keyup(function () {
                    if (changeTimeout != null) {
                        clearTimeout(changeTimeout);
                        changeTimeout = null;
                    }
                    changeTimeout = setTimeout(onChange, 2000);
                });

                $elem.change(onChange);
            } else if (inputType == FilterInputType.ACCUMULATOR_WITH_OPERAND) {

                function onChangeRecordNumber() {
                    if (changeRecordNumberTimeout != null) {
                        clearTimeout(changeRecordNumberTimeout);
                        changeRecordNumberTimeout = null;
                    }
                    var val = $input.val();
                    if (val == oldVal) {
                        return;
                    }
                    oldVal = val;

                    if (val == '') {
                        onChangeOperand(recordFilter, $.extend({},recordFilter.getOperand(),{value: null}) );
                        return;
                    }

                    val = parseInt(val, 10);

                    if (isNaN(val) || val <= 0) {
                        $input.addClass('error');
                        onChangeOperand(recordFilter , $.extend({},recordFilter.getOperand(),{value: null}));
                        return;
                    }

                    $input.removeClass('error');


                    onChangeOperand(recordFilter , $.extend({},recordFilter.getOperand(),{value: val}) );
                };

                var $input = $('<input type="text"></input>');

                if (recordFilter.getOperand().value !== null) {
                    $input.val(recordFilter.getOperand().value);
                }

                var oldVal = $input.val();

                var changeRecordNumberTimeout = null;
                options.enableFilterOnKeyUp && $input.keyup(function () {
                    if (changeRecordNumberTimeout != null) {
                        clearTimeout(changeRecordNumberTimeout);
                        changeRecordNumberTimeout = null;
                    }
                    changeRecordNumberTimeout = setTimeout(onChangeRecordNumber, 2000);
                });

                $input.change(onChangeRecordNumber);

                var label = function(text) {
                    return $('<label>',{text: text});
                };
                $elem = $('<div>').append($input).append(label(TLang['Values']));
                if(recordFilter.operandNeedFieldId()) {
                    var $selectDistinct = $('<select>');
                    $selectDistinct.append($('<option>',{text: TLang['None'],value: ''}));
                    fields.forEach(function(field) {
                        var $option = $('<option>');
                        $option.attr('value',field.id);
                        $option.text(field.name);
                        $selectDistinct.append($option);
                    });
                    if(recordFilter.getOperand().field_id) {
                        $selectDistinct.val(recordFilter.getOperand().field_id);
                    }else {
                        $selectDistinct.val('');
                    }
                    $selectDistinct.change(function() {
                        onChangeOperand(recordFilter,
                            $.extend({},recordFilter.getOperand(),{field_id: $selectDistinct.val()}) );
                    });
                    $elem.append(label(TLang['with'])).append($selectDistinct).append(label(TLang['distinct']));
                }

			}
			if($elem){
				$elem.addClass('recordFilterInput');
				return $elem;
			}
        };

		function getLinkSelectValues(field, selectedMap, callback){
			const maxRows = 100;
			var targetCategoryId, targetFieldId,view_id=null;
			if(field.link){
				targetCategoryId = field.link.category.id;
				targetFieldId = field.link.field.id;
                view_id = field.link.view_id;
			}
			else if(field.lookup){
				targetCategoryId = field.lookup.resolved.category.id;
				targetFieldId = field.lookup.resolved.field.id;
                view_id = field.lookup.view_id;
			}
            var filterRowIds = view_id ? {applyViewFilters: view_id} : null;

			$.ajax({
				type: "POST",
				dataType: "json",
				url		: apiEndpointUrl + "?getCarnetFormCategory",
				data: {
					indexVNB 		: indexVNB,
					session			: sessionNB,
					live			: 'yes',
					newDashboard	: "getCarnetFormCategory",
					category_id 	: targetCategoryId,
					filterRowIds    : filterRowIds,
					maxRows         : maxRows,
					field_ids       : [targetFieldId],
				},
				success: function(donnees) {
					if (donnees=='reload') {
						windowReload();
					}
	
					if(donnees && donnees.status=="ok") {
						var targetField = findById(donnees.category.fields,targetFieldId);

						if(targetField){
							var values = [];
							var valueMap = {};
							for(var i = 0; i < targetField.values.length; i++){
								if(!valueMap[targetField.values[i].value] && targetField.values[i].value){
									values.push({
										selected: selectedMap[targetField.values[i].value + ''],
										value: targetField.values[i].value,
										text: targetField.values[i].value
									});
									valueMap[targetField.values[i].value] = true;
								}
							}
						}

						callback(values, targetField.values.length >= maxRows);
					}
				},
				async: true
			});
		}

        function enumColorValueToOption(displayColor,selectedMap,enumColorValue) {
            return {
                text: enumColorValue.value,
                color: displayColor ? enumColorValue.color : null,
                selected: selectedMap[enumColorValue.value + '']
            };
        }

        function mergeCondEnumColors(condEnumColors) {
            var processed = {},
                result=[];
            Object.keys(condEnumColors).forEach(function(key) {
                var enumColor = condEnumColors[key];
                for(var i=0;i<enumColor.values.length;i++) {
                    if(!processed[enumColor.values[i].value]) {
                        result.push(enumColor.values[i]);
                        processed[enumColor.values[i]] = true;
                    }
                }
            });

            return result;
        }

        function createPredicateSelect(recordFilter, field, $inputCell, fields) {

            var predicates = recordFilter.getPredicateList();
            var $elem = $('<select name="predicates"></select>');
            for (var i = 0; i < predicates.length; i++) {
                $elem.append($('<option value="' + predicates[i] + '"></option>').text(TLang['filters.' + predicates[i]]));
            }
            $elem.change(function (event) {
                var oldReady = recordFilter.isReady();
                var oldInputType = getFilterInputType(recordFilter, field);
                recordFilter.setPredicate($(this).val());

                var newType = getFilterInputType(recordFilter, field);
                if (oldInputType != newType) {
                    if (newType == FilterInputType.BOOLEAN) {
                        recordFilter.setOperand(0);
                    } else if (newType == FilterInputType.ACCUMULATOR_WITH_OPERAND) {
                        var maxLength = parseInt((recordFilter.getOperand() && recordFilter.getOperand().value) || 1, 10);
                        if (isNaN(maxLength) || maxLength <= 0) {
                            maxLength = 1;
                        }
                        recordFilter.setOperand({value: maxLength});
                    } else {
                        recordFilter.setOperand(null);
                    }
                    $inputCell.empty().append(createFilterInput(recordFilter, field, fields));
                }

                triggerFiltersChanged();
                if (oldReady != recordFilter.isReady() || recordFilter.isReady()) {
                    setRecordFilterCount();
                    refilter();
                }

            });
            $elem.val(recordFilter.getPredicate());
            return $elem;
        };

        function createFieldSelect($table, fields, recordFilter, filterGroup, $prefixCell, $predicateCell, $inputCell, $deleteCell) {
            var $elem = $('<select name="fields"></select>');
            for (var i = 0; i < fields.length; i++) {
				if(fields[i].sysFunc != 1) {
                	var name = fields[i].name;                                    
					$elem.append($('<option value="' + fields[i].id + '"></option>').text(name));
                }                
            }
            var fieldId = filterGroup.getFieldId(filterGroup.indexOf(recordFilter));
            $elem.val(fieldId);
            $elem.change(function () {
                var newFilter;
                var field = findById(fields, $(this).val());
				if (!field) {
                    return ;
                }
				if (recordFilter instanceof RecordGroupBy) {
					filterGroup.setAt(filterGroup.indexOf(recordFilter), recordFilter, field.id);
					newFilter = recordFilter;
				} else {
					newFilter = RecordFilterFactory.createFilter(field);
					var index = filterGroup.indexOf(recordFilter);
					filterGroup.setAt(index, newFilter, field.id);
					$prefixCell.empty().append(createRowPrefix($table, fields, filterGroup, index));
					$predicateCell.empty().append(createPredicateSelect(newFilter, field, $inputCell, fields));
					$inputCell.empty().append(createFilterInput(newFilter, field,fields));
					$deleteCell.empty().append(createRowDelete($table, fields, filterGroup, newFilter));
					$prefixCell.parent().attr("id",newFilter.id);
				}
				var needRefilter = recordFilter instanceof RecordGroupBy ||
					(newFilter.isReady() && recordFilter.isReady()) || newFilter.isReady() != recordFilter.isReady();
				recordFilter = newFilter;
				triggerFiltersChanged();
				if (needRefilter) {
					setRecordFilterCount();
					refilter();
				}
            });

            return $elem;
        };
        function createRowPrefix($table, fields, filterGroup, index) {
            var gbCount = filterGroup.countGroupBy(),
                $elem,
                shiftedIndex = index - gbCount,
                operation  ;

            if (shiftedIndex < 0) {
                operation = 1;
            } else if (shiftedIndex == 0) {
                operation = 2;
            } else if (shiftedIndex == 1) {
                operation = 3;
            } else {
                operation = 4;
            }


            //#1
            if (operation == 1) {
                return $('<div>' + TLang['Group by'] + '</div>');
            }
            //#2
            if (operation == 2) {
                return $('<div>' + (options.conditionalVisibility ? TLang['Display if'] : TLang['Filter']) + '</div>');
            }

            //#3
            if (operation == 3) {
                $elem = $('<select></select>');
                $elem.append($('<option></option>').attr('value', 'and').text(TLang['And']));
                $elem.append($('<option></option>').attr('value', 'or').text(TLang['Or']));
                $elem.val(filterGroup.getOperator());
                $elem.change(function () {
                    filterGroup.setOperator($elem.val());
                    var $firstCells = $table.find('tr.filterRow > td:nth-child(2)');
                    for (var i = 0; i < $firstCells.length; i++) {
                        $firstCells.eq(i).empty().append(
                            createRowPrefix($table, fields, filterGroup, filterGroup.countGroupBy()+i)
                        );
                    }

                    triggerFiltersChanged();
                    if (filterGroup.getReadyFilterCount()) {
                        refilter();
                    }
                });
                return $elem;
            }

            //#4
            return $('<div></div>').text(filterGroup.getOperator() == 'and' ? TLang['And'] : TLang['Or']);

        };


        function createRowDelete($table, fields, filterGroup, recordFilter) {
            var $elem = $('<span title="'+TLang['Remove this filter']+
                '" class="ion-ios-trash-outline recordFilterDelete"></span>');
            $elem.click(function (event) {
                var index = filterGroup.indexOf(recordFilter);
                var oldReadyCount = filterGroup.getReadyFilterCount();
                filterGroup.removeAt(index);
                $elem.closest('tr.filterRow').remove();

                if( !(recordFilter instanceof RecordGroupBy) ) {
                    var $firstCells = $table.find('tr.filterRow > td:nth-child(2)');
                    for (var i = 0; i < $firstCells.length; i++) {
                        $firstCells.eq(i).empty().append(
                            createRowPrefix($table, fields, filterGroup, filterGroup.countGroupBy()+i)
                        );
                    }
                }
                triggerFiltersChanged();
                if (oldReadyCount != filterGroup.getReadyFilterCount()) {
                    setRecordFilterCount();
                    refilter();
                }

            });
            return $elem;
        };

        function appendFilterRow($table, fields, recordFilter, filterGroup) {
            var index = filterGroup.indexOf(recordFilter);
            var $tr = $('<tr class="filterRow"></tr>');

            var $dragCell = $('<td class="dragCell"></td>');
            var $firstCell = $('<td></td>');
            var $predicateCell = $('<td></td>');
            var $inputCell = $('<td></td>');
            var $deleteCell = $('<td></td>');

            $dragCell.append($('<span class="ion-drag"></span>'));
            $tr.append($dragCell);

            $firstCell.append(createRowPrefix($table, fields, filterGroup, index));
            $tr.append($firstCell);

            var $fieldCell = $('<td></td>');
            $fieldCell.append(createFieldSelect($table, fields, recordFilter, filterGroup, $firstCell, $predicateCell, $inputCell, $deleteCell));
            $tr.append($fieldCell);

            var field = findById(fields, filterGroup.getFieldId(index));
			
			if (field) {
				$predicateCell.append(createPredicateSelect(recordFilter, field, $inputCell, fields));
				$tr.append($predicateCell);


				$inputCell.append(createFilterInput(recordFilter, field, fields));
				$tr.append($inputCell);

				$tr.append($deleteCell.append(createRowDelete($table, fields, filterGroup, recordFilter)));
				$tr.attr("id",recordFilter.id);

				$table.append($tr);
			}

            return $tr;
        };

        function generateEnumAutocomplete($elem,enumColors,onChange) {
            var suggestions = enumColors.values.map(function(item) {
                return item.value;
            });
            $elem.autocomplete({
                width: '100%',
                lookup: {
                    suggestions: suggestions,
                    data: suggestions
                },
                onSelect: function () {
                    onChange();
                }
            });
        }

        function generateLinkFilterAutocomplete($elem,field,onChange) {
            var target = field.type==="link" ? field.link : field.lookup.resolved;
            var view_id = field.type==="link" ? field.link.view_id : field.lookup.view_id;
            var filterRowIds = view_id ? {applyViewFilters: view_id} : null;
            $elem.autocomplete({
                serviceUrl: apiEndpointUrl,
                params: {
                    newDashboard    : "autoFillCarnetFormValues",
                    category_id     : target.category.id,
                    field_id        : target.field.id,
                    includeFirstImage : true,
                    filterRowIds      : filterRowIds,
                },
                width:400,
                stopMouseDownPropagation: true,
                fnFormatResult : function(value, data, currentValue) {
                    var pattern = '(' + escapeRegexChars(currentValue) + ')';
                    var result = value.replace(new RegExp(pattern, 'gi'), '<strong>$1<\/strong>');
                    if(data.img) {
                        result = "<img class='ShdImg' src='" + data.img  + "'/>" + ' ' + result;
                    }else {
                        result = '<span class="emptyImgAutocomplete"></span>' + ' ' + result;
                    }
                    return result;
                },
                autoSelectFirstAvailableOption: true,
                onSelect: function (suggestion,data) {
                    $elem.val(data.value);
                    onChange();
                }
            });
        }

        return {
            "$simplePopup": $simplePopup
            , triggerFiltersChanged: function() {
                triggerFiltersChanged();
                setRecordFilterCount();
                refilter();
            }
        };

    };

    function hasEmptyValue(values) {
        for (var i = 0; i < values.length; i++) {
            if (values[i].value === null || values[i].value === '') {
                return true;
            }
        }
        return false;
    };


    function arrayDistinctValues(values,extractValueField) {
    	if (values === undefined) {
    		values = null;
    	}
    	if (extractValueField === undefined) {
    		extractValueField = false;
    	}
    	var distinctValues = [];
    	if (isJson(values)) {
    		values = JSON.parse(values);
    	}

    	if (Array.isArray(values)) {
	    	for (var i=0; i < values.length; i++) {
	    		var value = values[i];
	    		if (value!=undefined) {
		    		if (extractValueField && value.value!== undefined) {
		    			value = value.value;
		    		}
	    			if (distinctValues.indexOf(value)===-1) {
	    				distinctValues.push(value);
	    			}
	    		}
	    	}
    	}
    	else {
    		distinctValues.push(values);
    	}
    	return distinctValues;
    };

    // Get values of 'n' (default 1) number of fields of a given table (category). By default will be synchronously
    // and will wait for completion and return with the values
    function getCategory(tableId,nbFields,async) {
        var category;
        nbFields = (typeof nbFields == 'undefined') ? 1 : nbFields;
        async = (typeof async == 'undefined') ? false : async;
        $.ajax({
            type: "POST",
            dataType: "json",
            url     : apiEndpointUrl,
            data: {
                indexVNB        : indexVNB,
                session         : sessionNB,
                live            : 'yes',
                newDashboard    : "getCarnetFormCategory",
                onlyFirstFields : nbFields,
                category_id     : tableId
            },
            success: function(donnees) {
                if (donnees=='reload') {
                    windowReload();
                }
                if(donnees && donnees.status=="ok" && donnees.category) {
                    category = donnees.category;
                }
            },
            error: function() {
                if(onError) {
                    onError();
                }
            },
            async: async
        });
        return category;
    };


	// Get values of 'n' (default 1) number of fields of a given table (category). By default will be synchronously
	// and will wait for completion and return with the values
    function getTableValues(tableId,nbFields,async) {
		var values = [];
		nbFields = (typeof nbFields == 'undefined') ? 1 : nbFields;
		async = (typeof async == 'undefined') ? false : async;
        $.ajax({
            type: "POST",
            dataType: "json",
            url     : apiEndpointUrl,
            data: {
                indexVNB        : indexVNB,
                session         : sessionNB,
                live            : 'yes',
                newDashboard    : "getCarnetFormCategory",
				onlyFirstFields : nbFields,
                category_id     : tableId
            },
            success: function(donnees) {
                if (donnees=='reload') {
                    windowReload();
                }
                if(donnees && donnees.status=="ok" && donnees.category) {
					values = donnees.category.fields;
                }else if(onError) {
                    onError(donnees.status);
                }
            },
            error: function() {
                if(onError) {
                    onError();
                }
            },
            async: async
        });
		return values;
	};

    // Get values of 'n' (default 1) number of fields of a given table (category). By default will be synchronously
    // and will wait for completion and return with the values
    function getLinkValues(link, tab_id) {
        var values = [];
        
        var nbFields = 1;
        var async = false;
        var category_id = link.category.id;
        var filterRowIds = {};

        if(link.view_id) {
            filterRowIds.applyViewFilters = link.view_id;
            filterRowIds.applyOnlySort = false;
        }

        $.ajax({
            type: "POST",
            dataType: "json",
            url     : apiEndpointUrl + "?getCarnetFormCategory",
            data: {
                indexVNB        : indexVNB,
                session         : sessionNB,
                timestamp       : getTTCtimestamp(),
                live            : 'yes',
                newDashboard    : "getCarnetFormCategory",
                linkOnly        : true,
                onlyFirstFields : nbFields,
                category_id     : category_id,
                filterRowIds    : filterRowIds,
                tab_id          : tab_id,
            },
            success: function(donnees) {
                if (donnees=='reload') {
                    windowReload();
                }
                if(donnees && donnees.status=="ok" && donnees.category) {
                    values = donnees.category.fields;
                }
            },
            error: function() {
                if(onError) {
                    onError();
                }
            },
            async: async
        });
        return values;
    };

    function extractDistinctValues(field, formatValueCallback, withCase, isVertical, dateExtendIte) {
    	var value, elems, element, newElem, i, j, compare, indexElem, origin;
        var cols = [], uniqueElems = [];
        var addEmptyValue = false;
				if (typeof field == 'undefined') {
					return cols;
				}
        if ($.inArray(field.type,["link","files","lookup"])>-1) {
            var values = field.values;

            for (var i=0; i < values.length; i++) {
            	value = values[i];
            	if (value != null && value != undefined) {
					elems = value.value;
					if (elems!= null && elems != undefined) {
						for (j = 0; j < elems.length; j++) {
							element = elems[j];
							var valueElem, formatElem;
							valueElem = (element.value) ? element.value : element.url;
							formatElem = (element.value) ? element.value : element.name;
                            if(formatElem && field.link){
                                formatElem = formatValueCallback(field.link.field,formatElem);
                            }

							if (valueElem != undefined) {
								indexElem = uniqueElems.indexOf(valueElem);
								if (indexElem===-1) {
									newElem = {value:valueElem, formatted: formatElem, original: [element]};
									cols.push(newElem);
									uniqueElems.push(valueElem);
								}
								// If already in there, add the element to the list of elements
								else {
									newElem = cols[indexElem];
									origin = newElem.original;
									origin.push(element);
                                    newElem.original = origin;
									cols[indexElem] = newElem;
								}
							}
						}
					}
					else
						addEmptyValue = true;
				}
            	else
            		addEmptyValue = true;
			}
            if (cols.length) {
	            cols = cols.sort(function (a, b) {
	            	return a.value.localeCompare(b.value);
	            });
            }
        }
        else if (field.enumColors && field.enumColors.values.length) {
            cols = field.enumColors.values.map(function (item) {
                return {
                    value: item.value,
                    formatted: item.value,
                    original: item.value
                };
            });
            addEmptyValue = hasEmptyValue(field.values);
            if (field.enumColors.strict) {
            	// If not strict, may have extra values: Add them to the column choice
                var values = field.values;
                var extraCols = [];
                for (var i=0; i < values.length; i++) {
                	var ovalue = values[i].value;
                	var found = false;
                	for (var j=0; j<field.enumColors.values.length && !found;j++) {
                		if (ovalue == field.enumColors.values[j].value) {
                			found = true;
                		}
                	}
            		if (!found) {
                        var formatted = formatValueCallback(field,ovalue);

                        if (ovalue !== null && ovalue !== '') {
                            extraCols.push({formatted: formatted, value:formatted, original: ovalue});
                        } else {
                            addEmptyValue = true;
                        }
            		}
                }
                if (extraCols.length) {
    	            compare = getCompareFunction(field.type, withCase);
    	            extraCols = sortUnique(extraCols, function (a, b) {
    	                return compare(a.value, b.value);
    	            });
                }
                cols = cols.concat(extraCols);
            }
        }
        else if (field.type == "boolean") {
            var formatted = formatValueCallback(field,1);
            cols.push({formatted: formatted, value:formatted, original: 1});
            var formatted = formatValueCallback(field,0);
            cols.push({formatted: formatted, value:formatted, original: 0});
        }
        else if (field.type == "date"){
            values = field.values;
            addEmptyValue = false;
            for (var i=0; i < values.length; i++) {
            	var ovalue = values[i].value;
                var formatted = formatValueCallback(field,ovalue);
                var fieldWithValue = $.extend({},field,{value: formatted});
                    formatted = valueAsText(fieldWithValue,{
                    dateFormat: {
				        display: field.dateFormat ? field.dateFormat : "YYYY-MM-DD",
				        date: "YYYY-MM-DD"
                    },
                    hideTime: true
				});

                if (ovalue !== null && ovalue !== '' && (typeof formatted) != 'undefined') {
                    cols.push({formatted: formatted, value:formatted, original: ovalue});
                } else {
                    addEmptyValue = true;
                }
            }
            if (cols.length) {
	            compare = getCompareFunction(field.type, withCase);
	            cols = sortUnique(cols, function (a, b) {
	                return compare(a.value, b.value);
	            });
            }
        } else {
            values = field.values;
            addEmptyValue = false;
            for (var i=0; i < values.length; i++) {
            	var ovalue = values[i].value;
                var formatted = formatValueCallback(field,ovalue);

                if (ovalue !== null && ovalue !== '' && (typeof formatted) != 'undefined') {
                    cols.push({formatted: formatted, value:formatted, original: ovalue});
                } else {
                    addEmptyValue = true;
                }
            }
            if (cols.length) {
	            compare = getCompareFunction(field.type, withCase);
	            cols = sortUnique(cols, function (a, b) {
	                return compare(a.value, b.value);
	            });
            }
        }

        if (isVertical && dateExtendIte) {
          var d = new Date();
          var day = d.getDate().toString();
          if (day.length == 1) {
            day = '0'+day;
          }
          var month = (d.getMonth()+1).toString();
          if (month.length == 1) {
            month = '0'+month;
          }
          var year = d.getFullYear().toString();
          var today = year+'-'+month+'-'+day;
          var nextDay, nextDayObj, myDay, nextDayYear, nextDayMonth, nextDayDate;
          var colsTest = cols;

          for (var i = 0; i < dateExtendIte ; i++) {
            if (i == 0) {
              nextDay = today;
            } else {
              nextDayObj = new Date();
              nextDayObj.setDate(d.getDate()+i);
              nextDayYear = nextDayObj.getFullYear().toString();
              nextDayMonth = (nextDayObj.getMonth()+1).toString();
              if (nextDayMonth.length == 1) {
                nextDayMonth = '0'+nextDayMonth;
              }
              nextDayDate = nextDayObj.getDate().toString();
              if (nextDayDate.length == 1) {
                nextDayDate = '0'+nextDayDate;
              }
              nextDay = nextDayYear+'-'+nextDayMonth+'-'+nextDayDate;
            }

            myDay = nextDay;

            for (var j = 0; j < colsTest.length; j++) {
              var startDate = new Date(myDay);
              var endDate = new Date(colsTest[j].value);
              if ((startDate-endDate) < 0) {
                var placement = j;
                break;
              } else {
                placement = false;
              }

              var found = false;
              if (myDay == colsTest[j].value) {
                found = true;
                break;
              }
            }

            if (found === false) {
              if (placement) {
                cols.splice(placement,0,{formatted: myDay, value: myDay, original: myDay});
              } else {
                cols.push({formatted: myDay, value: myDay, original: myDay});
              }
            }
          }
        }

        if (addEmptyValue) {
            cols.push({formatted: '', value: '', original: null});
        }

        return cols;
    };

    function sumJsonCellValue(cellValue) {
    	if (cellValue==null) {
    		return null;
    	}
			if (isJson(cellValue)) {
				cellValue = JSON.parse(cellValue);
			}
			if (Array.isArray(cellValue)) {
				var cellTotal = 0;
				for (var k=0; k < cellValue.length; k++) {
		    		var cell = cellValue[k];
		    		if (cell!=undefined) {
			    		cellTotal += cell.value ? cell.value : cell;
		    		}
				}
				cellValue.value = cellTotal;
			}
			if (cellValue.value) {
				cellValue = cellValue.value;
			}
			return cellValue;
    };

    // formatters
    function formatJSONCell(field, rowIdx, fieldC, formatValueCallback) {
        row = field.values[rowIdx];
        value = formatValueCallback(field, row.value);
        colorValue = fieldC? formatValueCallback(fieldC, fieldC.values[rowIdx].value): null;
        return JSON.stringify({
            'fri' : -1,
            'value': value,
            'valueId' : field.id,
            'rowinfo' : {'id': row.id},
            'type' : field.type,
            'color':  colorValue
        });
    };

    function formatJSONLinkCell(hKey, vKey, hField, vField, valField) {
        var hFieldTarget,vFieldTarget,linkCell;
        linkCell = {
            'fri' : -1,
            'value': null,
            'valueId': valField.id,
            'rowinfo': [
                (vField.link || vField.lookup) ?
                    ((vFieldTarget=getLinkTargetField(vField)) && 
                    {'id': vFieldTarget.id, 'value': vKey, 'type': vFieldTarget.type,linkId: vField.id}) :
                {'id': vField.id, 'value': vKey, 'type': vField.type},
                (hField.link || hField.lookup) ?
                    ((hFieldTarget=getLinkTargetField(hField)) && 
                    {'id': hFieldTarget.id, 'value': hKey, 'type': hFieldTarget.type,linkId: hField.id}) :
                {'id': hField.id, 'value': hKey, 'type': hField.type}
            ],
            'type': valField.type,
        };
        return JSON.stringify(linkCell);
    };

    class PivotCell {
        /**
        * Summary. Class constructor.
        *
        * Description. Create a new PivotCell object. 
        *
        * _Note. The distinct field could also be used for Numeric PivotCell to save all references (rowId)
        * used in the aggregate's computation. Just remove the else in the update method _
        *
        * @param {Boolean}  isNumeric   true if the content will come from a Numeric field
        */
        constructor(isNumeric, isEditableNumeric, isTotal) {
            this.isNumeric = isNumeric;
            this.isEditableNumeric = isEditableNumeric;
            this.isTotal = isTotal;
            this.sum = 0;
            this.count = 0; //distinct counter
            this.weightedCount = 0; // weighted distinct counter (if more than one hKey or vKey)
            this.average = 0;
            this.distinct =  [];
        }

        /**
        * Summary. Update a PivotCell.
        *
        * Description. Consider a new value and the type of the PivotCell (numeric or not) to update fields accordingly.
        *
        * @param {JSON}      cellValue      JSON object with row idx, row value and row id info 
        * @param {float}     weight     a weight diff from 1, if more than one related hKey or vKey
        */
        update(cellValue, weight = 1) {
            if (cellValue) {
                this.count = this.count + 1;
                this.weightedCount = this.weightedCount + weight;
                if (this.isNumeric && !this.isEditableNumeric || this.isTotal) { // update numeric operations
                    this.sum += (cellValue.row.value*weight) / 1;
                    var denom = this.count == 1 ? this.count: this.weightedCount; // weighted on average only if more than 1
                    this.average += (((cellValue.row.value*weight) - this.average)/ denom);
                } else {// update list of distinct value idx for a later rendering (see render method)
                    this.distinct.push(cellValue.rowIdx);
                }   
            }
            return this;
        }

        /**
        * Summary. Render a PivotCell. (client side ?)
        *
        * Description. Give an appropriate rendering to the PivotCell 
        *
        * @param {string}    aggregate     the aggregate to visualize
        * @param {pivotCell} percentageOf  the pivotCell to compute percentage Of
        * 
        * @return (Numeric) 2 decimal float or null; (NonNumeric) JSON object
        */
        render(aggregate = 'sum', percentageOf = null, valueField, colorField, formatValueCallback) {
           
            var value, rowIdx;

            if(aggregate == 'editable' && this.isTotal) {
                value = Number.parseFloat(this.sum).toFixed(2);
            }
            else if (this.isNumeric && !this.isEditableNumeric) {
                value = percentageOf? ((this[aggregate]/ percentageOf[aggregate]) * 100): this[aggregate];
                value = Number.parseFloat(value).toFixed(2);
           } else {
                rowIdx = this.distinct[0];
                value = formatJSONCell(valueField, rowIdx, colorField, formatValueCallback);
           }
           return value;
        }
    }


    class PivotTable {

        /**
        * Summary. Class constructor.
        *
        * Description. Create a new PivotTable object.
        *
        * @param {object} options all value ar optionals, defaults are:
        *        {
        *            //a light pivotTable renders a null cell instead of a JSONLinkCell 
        *            // (memory overflow on big table otherwise)
        *            isLight: false,
        *            //if required to see logs (debug mode)
        *            verbose: false,
        *            maxRow: 5000,
        *            //if true treat value as numeric values and enable aggregates
        *            isNumeric: false,
        *            //if true and isNumeric, this forces numbers to be editable cells
        *            isEditableNumeric: false
        *            
        *        }
        * @param {Boolean}  verbose              if required to see logs (debug mode)
        */
        constructor(options) {  

            var defaults = {
                isLight: false,
                verbose: false,
                maxRow: 5000,
                isNumeric: false,
                isEditableNumeric: false,
            };

            options = $.extend({},defaults,options);
            this.data = {};
            this.verticalKeys = {};
            this.horizontalKeys = {};
            this.matchCount = {};
            this.verbose = options.verbose;
            this.isLight = options.isLight;
            this.maxRow = options.maxRow;
            this.hKeySeparator = '_$_';
            // special conditions
            this.isNumeric = options.isNumeric;
            this.makeTotal = options.isNumeric;
            this.isEditableNumeric = options.isEditableNumeric;
        }

        /**
        * Summary. Return if total is computed (numeric values).
        *
        * @return {Boolean}  this.makeTotal
        */
        hasTotal() {
            return this.makeTotal;
        }


        /**
        * Summary. Getter for data field.
        *
        * Description. Data is a light datastructure: dictionnary of dictionnaries. 
        * Each cell are PivotCells (cf. PivotCell class).
        */
        getData() {
            return this.data;
        };

        /**
        * Summary. Getter for data field.
        *
        * Description. Data is a light datastructure: dictionnary of dictionnaries. 
        * Each cell are PivotCells (cf. PivotCell class).
        */
        freeMemory(hKey, vKey) {
            this.data[hKey][vKey] = null;
            //this.verticalKeys[vKey] = null;
            //this.horizontalKeys[hKey] = null;
        };

        

        /**
        * Summary. Setter for horizontalKeys.
        *
        * Description. This function will create all the data[hKey] that have to be in the final result.
        * It is useful for the case 'AllValuesOf' where all the values from the link table have to be
        * displayed, at least once. 
        */
        setHorizontalKeys(linkHValues, linkHField, formatValueCallback) {
            linkHValues.forEach(hKey => {
                var hKeyFormatted = formatValueCallback(linkHField, hKey.value);
                this.data[hKeyFormatted] = {};
                this.horizontalKeys[hKeyFormatted] = {};
            });
        };

        /**
        * Summary. Setter for verticalKeys.
        *
        * Description. This function will create all the data[vKey] that have to be in the final result.
        * It is useful for the case 'AllValuesOf' where all the values from the link table have to be
        * displayed, at least once. 
        */
        setVerticalKeys(linkVValues, linkVField, formatValueCallback) {
            linkVValues.forEach(vKey => {
                var vKeyFormatted = formatValueCallback(linkVField, vKey.value);
                this.data[vKeyFormatted] = {};
                this.verticalKeys[vKeyFormatted] = {};
            });
        };

        /**
        * Summary. Getter for verticalKeys field.
        *
        * Description. The vertical keys list is appropriate for Handson format and sorted if needed.
        * @return {list} empty field followed by vertical keys
        */
        getVerticalKeys(verticalField = null) {
			var verticalType = verticalField ? verticalField.type : null;
			var keysArr = Object.keys(this.verticalKeys);
			var dateFormat = verticalType == "date" ? verticalField.dateFormat : null;
            keysArr = (keysArr.length && verticalType)? keysArr.sort(getCompareFunction(verticalType, false, dateFormat)) : keysArr;
            return [""].concat(keysArr).concat(this.makeTotal?["Total"]:[]);
        };

        /**
        * Summary. Getter for horizontalKeys field.
        *
        * Description. The horizontal keys list is appropriate for Handson format.
        * @return {list} "Total" followed by horizontal keys
        */
        getHorizontalKeys() {
            return (this.makeTotal?["Total"]:[]).concat(Object.keys(this.horizontalKeys));
        };

        limitHorizontalKeys(conf){
            if(conf.checkedValues == 'all'){
                return;
            }else if(conf.checkedValues == 'none'){
                var authorizedKeys = [];
            }else if(conf.checkedValues){
                var authorizedKeys = conf.checkedValues;
            }else{
                return;
            }
            for(var k in this.horizontalKeys){
                if(authorizedKeys.indexOf(k) == -1 && this.horizontalKeys[k] != 'Total'){
                    delete this.horizontalKeys[k];
                }
            }
        };

        limitVerticalKeys(conf){
            if(conf.checkedValues == 'all'){
                return;
            }else if(conf.checkedValues == 'none'){
                var authorizedKeys = [];
            }else if(conf.checkedValues){
                var authorizedKeys = conf.checkedValues;
            }else{
                return;
            }
            for(var k in this.verticalKeys){
                if(authorizedKeys.indexOf(k) == -1 && this.verticalKeys[k] != 'Total'){
                    delete this.verticalKeys[k];
                }
            }
        };

        /**
        * Summary. Render the lightweight dictionary of dictionaries.
        *
        * Description. Generate a Handson formatted array. With H, V respectively Horizontal and Vertical keys list length:
        * Computational cost 0(H x V). (client side ?)
        *
        * @param {String} aggregate         aggregate operation to visualize in Handson cell
        * @param {String} toPercentage      boolean to compute Percentage of Total of Total
        * @param {JSON}   hField            JSON object with horizontal field, default null
        * @param {JSON}   vField            JSON object with vertical field, default null
        * @param {JSON}   valField          JSON object with value field, default null
        * @param {JSON}   colorField        JSON object with color field, default null
        * @param {function}   formatValueCallback        formatter Handson
        *
        * @return {list of list} Handson pivot table content, formatted on Handson table.
        */
        render(aggregate, toPercentage = false, hField, vField, valField, colorField, formatValueCallback) {
            var percentageOf = (toPercentage && this.data['Total'])? this.data['Total']['Total']: null;
            var cellValue;
            var verticalKeys = this.getVerticalKeys(vField);
            var horizontalKeys = this.getHorizontalKeys();
            this.result = [];
            try {
                horizontalKeys.forEach((hKey, hIdx) => {
                    this.result[hIdx] = [];
                    if (hIdx > this.maxRow) throw `Only the first ${this.maxRow} are visible.\nPlease, consider an other row field`; 
                    verticalKeys.forEach((vKey, vIdx) => {
                        if (vIdx == 0) {
                            // first column contains horizontal keys
                            var hKeyFinal = hKey.split(this.hKeySeparator)[0];
                            this.result[hIdx][vIdx] = (hKeyFinal == "null")? null : hKeyFinal;
                        } else {
                            this.result[hIdx][vIdx] = this.data[hKey] && this.data[hKey][vKey] ?
                                // if existing cell render numeric aggregate or nonNumeric JSONCell 
                                this.data[hKey][vKey].render(aggregate, percentageOf,
                                    valField, colorField,
                                    formatValueCallback): 
                                // else if numeric or light: null cell;
                                (((this.isNumeric && !this.isEditableNumeric) || this.isLight)? null:  
                                    // else: json link cell to allow direct updates from pivot table cells
                                    formatJSONLinkCell(hKey.split('_$_')[0], vKey, hField, vField, valField));
                        }
                         
                        //this.freeMemory(hKey.split(this.hKeySeparator)[0], vKey); 
                        this.verbose ? console.log(hIdx, vIdx, this.result[hIdx][vIdx]) : null;
                    });
                });
            } catch (e) {alert(e);}
            return this.result;
        };

        /**
        * Summary. Update a PivotCell with new value.
        *
        * Description. Create or update the cell matching a hKey and vKey. If the pivotTable is nonNumeric,
        * a new Row is created with a distinct hkey. Note that the distinct hKey value is made using the matchCount
        * dictionnary. This enables keeping track of the hKey distinct values to update each column incrementally.
        * 
        * @param {String}    hkey                 a horizontal key
        * @param {String}    vkey                 a vertical key
        * @param {JSON}      cellValue            JSON object with row idx, row value and row id info
        * @param {number}    weight               a weight for appropriate update  
        * @param {Boolean}   isTotal              a Boolean set to true during the update of Total cell only
        */
        update(hKey, vKey, cellValue, weight = 1, isTotal = false) {
            if (!isTotal) {
                if (!this.isNumeric || this.isEditableNumeric) {
                    // save match count to get appropriate hKey counter if necessary
                    this.matchCount[hKey] = this.matchCount[hKey] ? this.matchCount[hKey] : {};
                    this.matchCount[hKey][vKey] = this.matchCount[hKey][vKey] ? this.matchCount[hKey][vKey]+1 :1;
                    if ((hKey == null) && (cellValue.row.value == null) && (this.matchCount[null][null] >= 2)) {
                        return; // if all null and already had the null match, don't want more line: return
                    };
                    // horizontal key is hKey_$_{matchCount} if row non existant or if existant but non numeric 
                    hKey = (this.matchCount[hKey][vKey]==1)? hKey: `${hKey}${this.hKeySeparator}${this.matchCount[hKey][vKey]}`;
                }
                // save vertical/horizontal distinct keys with respective count (not accessible in 0(1) otherwise)
                this.verticalKeys[vKey] = this.verticalKeys[vKey]? this.verticalKeys[vKey]+1: 1;
                this.horizontalKeys[hKey] = this.horizontalKeys[hKey]? this.horizontalKeys[hKey]+1: 1;
            }
            // console.log(this.horizontalKeys);
            // update cellValue on existing cell or newly created cell
            this.data[hKey] = this.data[hKey]? this.data[hKey]: {};
            this.data[hKey][vKey] = this.data[hKey][vKey]? 
                this.data[hKey][vKey].update(cellValue, weight): (new PivotCell(this.isNumeric, this.isEditableNumeric, isTotal)).update(cellValue, weight);

            // update total with cellValue if needed
            if (this.makeTotal && (!isTotal)) {
                this.update('Total', vKey, cellValue, weight, true); // horizontal Total
                this.update(hKey, 'Total', cellValue, weight, true); // vertical Total
                this.update('Total', 'Total', cellValue, weight, true); // Total of Total
            } 
        }

		completeVerticalKeysForDateInterval(dateInterval,dateField) {
			var cur = moment(dateInterval.start);
			var endInterval = moment(dateInterval.end);
			var dateFormat = dateField.dateFormat ? dateField.dateFormat : 'YYYY-MM-DD';
			while((cur.format("YYYY-MM-DD")).localeCompare(endInterval.format("YYYY-MM-DD")) <= 0) {
				var renderString = cur.format(dateFormat);
				if(this.verticalKeys[renderString] === undefined) {
					this.verticalKeys[renderString] = 0;
				}
				cur = cur.add('days',1);
			}
		}
	}
    
    var generatePivotTableData_new_fieldGetValues = [];//uniquename
    function resetPivotTableData_new_fieldGetValues(){
        generatePivotTableData_new_fieldGetValues = [];
    }

    /**
        * Summary. Generate a content of pivot Table
        *
        * Description. Browse into the Category row values to update a PivotTable.
        * Computational cost O(N)
        *
        *
        * @param {JSON}   category               original category JSON object.
        * @param {JSON}   pivotCategory          generated pivot category JSON object.
        * @param {function} formatValueCallback should return a formatted value compatible with hot renderers
        * @param {function} formatKey function(field,value) should return a string suitable to display 
        *                             a hot column or row headers. 
        *                             (optional, default to linkValueAsText(field,value,{hideTime:true}))
        * 
        * @return {Handson} pivot table content, formatted on Handson table.
        */
    function generatePivotTableData_new(category, pivotCategory,formatValueCallback,formatKey) {

        // initialize variables
        // Horizontals means rows of pivot table
        // Verticals means columns of pivot table
        var result = [],
            horizontalFieldId=pivotCategory.p_field_hz,
            verticalFieldId=pivotCategory.p_field_vt,
            valueFieldId=pivotCategory.p_field_va,
            colorFieldId=pivotCategory.p_field_co,
            filterFieldId=pivotCategory.p_field_fltr,
            filterFieldViewId=pivotCategory.p_field_fltr_view_id,
            filterFieldValue=pivotCategory.p_field_fltr_value,
            dateExtend,
            headers = null,
            toPercentage = (pivotCategory.isAverageCalculation == 3 || pivotCategory.isAverageCalculation == 4);

        var userFieldConf = pivotCategory.pivotCategoryUserFieldConf || [],
            defaultConf = {pickValues: "created", checkedValues: "all"};
        var verticalFieldConf = Object.assign({},pivotCategory.p_field_vt_conf),
            horizontalFieldConf= Object.assign({},pivotCategory.p_field_hz_conf);
        
        if(!formatKey) {
            formatKey = function(field,value) {
                return linkValueAsText(field,value,{hideTime: true});
            };
        }
       
        // match fields id with value
        var valueFieldIndex = findIndexById(category.fields, valueFieldId);
        var colorFieldIndex = findIndexById(category.fields, colorFieldId);
        var filterFieldIndex = findIndexById(category.fields, filterFieldId);
        var verticalFieldIndex = findIndexById(category.fields, verticalFieldId);
        var horizontalFieldIndex = findIndexById(category.fields, horizontalFieldId);

        // if invalid fields: return empty pivot table
        // otherwise fill with proper values
        if (!(horizontalFieldIndex == -1 || verticalFieldIndex == -1 || valueFieldIndex == -1)) {
            var valueField = category.fields[valueFieldIndex];
            var colorField = category.fields[colorFieldIndex];
            var filterField = filterFieldIndex != -1?category.fields[filterFieldIndex]:null;
            // Make sure to get values from actual vertical/horizontal indexes 
            // not from conf indexes which are used for displaying rows/columns only 
            var verticalFieldValues = category.fields[verticalFieldIndex].values;
            var horizontalFieldValues = category.fields[horizontalFieldIndex].values;

            var verticalField = verticalFieldConf.field;
            if(typeof verticalFieldConf.field == "undefined")
                verticalFieldConf.field = category.fields[verticalFieldIndex];
            var verticalField = verticalFieldConf.field;
            verticalFieldConf = $.extend(verticalFieldConf,userFieldConf[verticalFieldId] || defaultConf);

            if(typeof horizontalFieldConf.field == "undefined")
                horizontalFieldConf.field = category.fields[horizontalFieldIndex];
            var horizontalField = horizontalFieldConf.field;
            horizontalFieldConf = $.extend(horizontalFieldConf,userFieldConf[horizontalFieldId] || defaultConf);

            var lenVerticals = verticalFieldValues.length;
            var lenHorizontals = horizontalFieldValues.length;
            var lenValues = valueField.values.length;
            var lenRows = Object.keys(category.rowInfos).length;
            /*
            console.log('lenVerticals:'+lenVerticals);
            console.log('lenHorizontals:'+lenHorizontals);
            console.log('lenValues:'+lenValues);
            console.log('lenRows:'+lenRows);
            */
            var aggregate = calculationModeValue[pivotCategory.isAverageCalculation];
            var hasNumericValues = isFieldTypeNumeric(valueField.type);
            var isLookupNumber = valueField.type == 'lookup' && 
                (valueField.lookup.field.type == 'double' || valueField.lookup.field.type == 'int');
            var isFormulaNumber = valueField.type == 'formula' && 
                (valueField.formula.outputType == 'double' || valueField.formula.outputType == 'int');
            var isNumeric = hasNumericValues || isLookupNumber || isFormulaNumber;


            // initialize empty pivot table
            var pivotTable = new PivotTable({
                isLight: (lenValues > 3000),
                isNumeric: isNumeric,
                isEditableNumeric: isNumeric && aggregate === 'editable',
            } );
       
            var linkHorizontalField = (horizontalField.link || horizontalField.lookup)? getLinkTargetField(horizontalField) : horizontalField;
            var linkVerticalField = (verticalField.link || verticalField.lookup)? getLinkTargetField(verticalField) : verticalField;
            var lookUpOfHori = (valueField.lookup && horizontalField.link && horizontalField.link.category.id == valueField.lookup.category.id);
            var lookUpOfVerti = (valueField.lookup && verticalField.link && verticalField.link.category.id == valueField.lookup.category.id);

            var getValues = function(field){
                var retValues = generatePivotTableData_new_fieldGetValues[field.id];
                if(retValues) 
                    return retValues;
                // If link, fetch values of linked table from server
                if(field.type == "link") {
                    retValues = getLinkValues(field.link, category.externInfos?category.externInfos.tab_id:null)[0];
                    generatePivotTableData_new_fieldGetValues[field.id] = retValues;
                    return retValues;
                }
                if(field.type == "lookup") {
                    fieldCopy = Object.assign({}, field);
                    var outValues = [];
                    fieldCopy.values.forEach(function(value){
                        value.value && value.value.forEach(function(item){
                            outValues.push({id: item.row_id.toString(), value: item.value});
                        });
                    });
                    fieldCopy.type = 'mediumtext';
                    fieldCopy.values = outValues;
                    retValues = fieldCopy;
                    generatePivotTableData_new_fieldGetValues[field.id] = retValues;
                    return retValues;
                }
            };

            // if allValuesOf, force all extern values to be at least once in the final pivot table
            if(horizontalFieldConf && horizontalFieldConf.pickValues == 'all'){
                var linkHField = getValues(horizontalFieldConf.field);
                if (typeof linkHField != "undefined") {
                    pivotTable.setHorizontalKeys(linkHField.values,linkHField,formatKey);
                }
            }
            if(verticalFieldConf && verticalFieldConf.pickValues == 'all'){
                var linkVField = getValues(verticalFieldConf.field);
                if (typeof linkVField != "undefined") {
                    pivotTable.setVerticalKeys(linkVField.values,linkVField,formatKey);
                }
            }

            var isInConf = function(key, conf){
                if(conf.checkedValues == 'all'){
                    return true;
                }else if(conf.checkedValues == 'none'){
                    return false;
                }else if(conf.checkedValues){
                    return conf.checkedValues.indexOf(key) != -1;
                }else{
                    return true;
                }
            };
            
            for (var i = 0; i < lenValues; i++) {
                var row = valueField.values[i];
                var rowValues = Array.isArray(row.value)? row.value:
                    [{"value": row.value}];
                var hKey = horizontalFieldValues[i].value;
                var vKey = verticalFieldValues[i].value;
                var hKeys = Array.isArray(hKey)? hKey:
                    [{"value":  hKey}]; // case for hKey with multiple values (link table)
                var vKeys = Array.isArray(vKey)? vKey:
                    [{"value":  vKey}]; // case for vkey with multiple values (link table)
                var weight = valueField.lookup ? 1: 1 / (hKeys.length * vKeys.length); // weight proportional to the number of k keys (1/k)
                if(filterField && !isValueInLink(filterFieldValue,filterField.values[i].value)){
                    continue;
                }
                hKeys.forEach((h, hIdx) => vKeys.forEach(function(v, vIdx){
                    var hkey = formatKey(linkHorizontalField, h.value);// appropriate format keys
                    var vkey = formatKey(linkVerticalField, v.value);
                    if(isInConf(hkey, horizontalFieldConf) && isInConf(vkey,verticalFieldConf))
                    pivotTable.update(
                        hkey,
                        vkey,
                        {
                            rowIdx: i,
                            row: rowValues.filter(rowValue => (lookUpOfHori? rowValue.row_id == h.row_id :
                            (lookUpOfVerti? rowValue.row_id == v.row_id: true)))[0] // case for lookup column of another table
                        },
                        weight);
                }   
                ));
            }// populate pivot table (server side)
            
            if(horizontalFieldConf) pivotTable.limitHorizontalKeys(horizontalFieldConf);
            if(verticalFieldConf) pivotTable.limitVerticalKeys(verticalFieldConf);

            if(verticalField.type==="date" && (dateExtend=getPivotDateExtend(pivotCategory)) ) {
                pivotTable.completeVerticalKeysForDateInterval(dateExtend,verticalField);
            }
            // render Handson pivot table (client side)
            result = pivotTable.render(calculationModeValue[pivotCategory.isAverageCalculation],
                toPercentage, horizontalField, verticalField, valueField,
                colorField, formatValueCallback);
            headers = pivotTable.getVerticalKeys(linkVerticalField);
		}
        return {
                rows: result,
                headers: headers,
                hasTotal: pivotTable && pivotTable.hasTotal(),
                numericValues: pivotTable && pivotTable.isNumeric,
                horizontalField: horizontalField,
                verticalField: verticalField,
                horizontalFieldConf: horizontalFieldConf,
                verticalFieldConf: verticalFieldConf,
                valueField: valueField,
                colorField: colorField,
                readOnly: pivotTable && pivotTable.isNumeric && !pivotTable.isEditableNumeric,
                mergeCells: []
            };

    };

    function isValueInLink(stringValue,fieldLinkValue){
        for(i in fieldLinkValue){
            if(fieldLinkValue[i].value == stringValue){
                return true;
            }
        } 
        return false;
    }


    function getPivotDateExtend(pivotCategory) {
        if(!pivotCategory.p_des || !pivotCategory.p_dee || 
            pivotCategory.p_des.localeCompare(pivotCategory.p_dee) >= 0) {
            return null;
        }
        return {start: pivotCategory.p_des,end: pivotCategory.p_dee};
    }

	function findNumericResults(elements){
		return elements.filter(function(element){
			return (element && !isNaN(element) && element != null);
		});
	};

    function elementInField(element,fieldValue,fieldType,withCase) {
    	var result;
    	if (element === null && fieldValue === null) {
    		return true;
    	}
    	if (isJson(element)) {
    		element = JSON.parse(element);
    	}
    	// Check if element is any one of the link values which can contain multiple
    	if ($.inArray(fieldType,["link","files","lookup"])>-1) {
    	//else if (fieldType == "link") {
    		compare = getCompareFunction("string", false);
    		if (element === null) {
    			return false;
			} else if (fieldValue === null) {
    			return false;
			} else {
    			for (var i=0; i<fieldValue.length;i++) {
    				if (fieldValue[i].value !== undefined) {
    					result = compare(element, fieldValue[i].value);
    				} else if (fieldValue[i].url != undefined) {
    					result = compare(element, fieldValue[i].url);
    				} else {
    					result = -1;
					}
    				if (result == 0) {
    					return true;
    				}
    			}
    		}
    		return false;
    	}
    	// Otherwise check if they are the name (comparaison should return 0
    	else {
    		compare = getCompareFunction(fieldType, withCase);
            return compare(element, fieldValue) == 0;
    	}
    };

    function createColInfoButton(field){
        if(typeof field.description == "undefined" || field.description == null || field.description == "" )
            return null;
        $infoIcon = $('<span class="colInfoTool glyphicon glyphicon-info-sign"></span>');
        $infoIcon.mouseover(function(event){
            var infopopup = $('<div class="infoField" >'+field.description+'</div>');
            var position = $(event.target).offset();
                infopopup.css({
                    position: 'absolute',
                    zIndex: 9999,
                    left: position.left + 'px',
                    top: position.top + 32 + 'px',
                });
            $('body').append(infopopup);
        });
        $infoIcon.mouseout(function(event){
            $('.infoField').remove();
        });
        return $infoIcon;
    }

    function getCompareFunction(fieldType, withCase, dateFormat) {
        if (fieldType == 'int' || fieldType == 'double') {
            return numberCompare;
        }

        if (fieldType == 'boolean') {
            return booleanCompare;
		}
		
		if (fieldType == "date" && dateFormat){
			//This function needs an external parameter
			return function (a, b){
				if (a === '' || b === ''){
					return emptyStringToEnd(a, b);
				}
				if (a === b) {
					return 0;
				}
				if (moment(a,dateFormat).isBefore(moment(b,dateFormat))){
					return -1;
				}
				if (moment(a,dateFormat).isSame(moment(b,dateFormat))){
					return 0;
				}
				if (moment(a,dateFormat).isAfter(moment(b,dateFormat))){
					return 1;
				}
			};
		}

        if (withCase) {
            return caseCompare;
        }
        return noCaseCompare;
    };


    function numberCompare(a, b) {
        if (a === '' || b === '') {
            return emptyStringToEnd(a, b);
        }
        return a * 1 - b * 1;
    };

    function booleanCompare(a, b) {
        if (a === '' || b === '') {
            return emptyStringToEnd(a, b);
        }
        if (a === b) {
            return 0;
        }
        if (a === true) {
            return -1;
        }
        return 1;
	};

    /**
     * new optional parameter valueType (type of cellValue. Default is double. Used for comparaison in min/max
     *
     * new optional parameter Formula (default is "sum" if undefined)
     * 	"sum"	Will make the sum of each values
     * 	"count"	Will count elements
     * 	"min"	Will find the minimum element
     * 	"max"	Will find the maxium element
     */
    function mergeValueInRow(row, colIndex, cellValue, valueType, mergeFormula) {
        if (cellValue === null) {
            return;
        }
        if (mergeFormula == undefined) {
        	mergeFormula = "sum";
        }
        if (valueType == undefined) {
        	valueType = "double";
        }
        if (row[colIndex] === null) {
            row[colIndex] = 0;
        }
        cellValue = sumJsonCellValue(cellValue);

		    switch (mergeFormula) {
	        case "sum":
	        	row[colIndex] = 1 * row[colIndex] + 1 * cellValue;
	        	break;
	        case "count":
	        	row[colIndex] = 1 * row[colIndex] + 1;
	        	break;
	        case "min":
            compare = getCompareFunction(valueType, false);
	        	if (compare(cellValue,row[colIndex]) < 0) {
	        		row[colIndex] = cellValue;
        		}
	        	break;
	        case "max":
                compare = getCompareFunction(valueType, false);
	        	if (compare(cellValue,row[colIndex]) > 0) {
	        		row[colIndex] = cellValue;
        		}
	        	break;
        }
        return row;
    };

    function mergeColorInRow(row, colIndex, rowColor) {
        if (rowColor === null) {
            return;
        }
        if (row[colIndex] === null) {
            row[colIndex] = rowColor;
        } else {
            row[colIndex] = 1 * row[colIndex] + 1 * rowColor;
        }
    };

    function emptyStringToEnd(a, b) {
        if (a === '' && b === '') {
            return 0;
        }
        if (a === '') {
            return 1;
        }
        // if(b==='') {
        return -1;
        // }
    };

    function noCaseCompare(a, b) {
        if (a === '' || b === '') {
            return emptyStringToEnd(a, b);
        }
        return (a + '').toLowerCase().localeCompare((b + '').toLowerCase());
    };

    function caseCompare(a, b) {
        if (a === '' || b === '') {
            return emptyStringToEnd(a, b);
        }
        return (a + '').localeCompare(b + '');
    };

	function isFieldNumeric(field) {
		if (field == undefined)
			return false;
		var hasNumericValues = isFieldTypeNumeric(field.type);
        var isLookupNumber = field.type == 'lookup' && (field.lookup.field.type == 'double' || field.lookup.field.type == 'int');
        var isFormulaNumber = field.type == 'formula' && (field.formula.outputType == 'double' || field.formula.outputType == 'int');
		return (hasNumericValues || isLookupNumber || isFormulaNumber);
	};

    function isFieldTypeNumeric(fieldType) {
        return fieldType == 'int' || fieldType == 'double' || fieldType == 'autonumber';
	};

    function findCategoryById(categories, cat_id) {
        for (var i = 0; i < categories.length; i++) {
            if (categories[i].id == cat_id) {
                return categories[i];
            }
        }
        return null;
    };

    function findCategoryIndexById(categories, cat_id) {
        for (var i = 0; i < categories.length; i++) {
            if (categories[i].id == cat_id) {
                return i;
            }
        }
        return -1;
    };

    function findSelectedView(category) {
        var index = findSelectedViewIndex(category);
        if (index == -1) {
            return null;
        }

        return category.views[index];
    };

    function findSelectedViewIndex(category) {
    	if (category.views == undefined) {
    		return -1;
    	}
        for (var i = 0; i < category.views.length; i++) {
            if (category.views[i].id == category.selectedViewId) {
                return i;
            }
        }

        return -1;
    };


    var parseDate = function (displayFormat, dataFormat, value) {
        if (value === null || value === '') {
            return {status: "ok", value: value};
        }

        var m = moment(value, displayFormat, true);
        if (!m.isValid()) {
            return {status: 'error', info: "Date format is " + displayFormat};
        }

        return {status: "ok", value: m.format(dataFormat)};
    };

    /**
     * Check if the supplied date matches one of the dataFormats
	 * NOTICE : Single digits are now accepted (eq : 8/1/2019)
     * @param array dataFormats : an array with a set of valid date formats
     * @param string value : supplied date as a string
     * @return true if the date format matches with one of the supplied date formats
     */
    var isValidDate = function(dataFormats,value){
        if(value === null || value === ''){
            return true;
        }

        for(var i=0;i<dataFormats.length;i++){
            var m = moment(value,dataFormats[i],true);
            if(m.isValid()){
                return true;
			}
			if(moment(value,dataFormats[i].replace("DD","D")).isValid() || moment(value,dataFormats[i].replace("MM","M")).isValid()){
				return true;
			}
			else{
				var singleDigitFormat = dataFormats[i].replace("DD","D");
				singleDigitFormat = singleDigitFormat.replace("MM","M");
				if(moment(value,singleDigitFormat,true).isValid()){
					return true;
				}
			}
        }
        return false;
    };

    var findIndexById = function (items, id) {
      if (items){
        for (var i = 0; i < items.length; i++) {
            if (items[i] && items[i].id == id) {
                return i;
            }
        }
      }
      return -1;
    };

 	var findById = function(items,id) {
		if (items && id) {
			for(var i=0;i<items.length;i++) {
				if(items[i] && items[i].id==id) {
					return items[i];
				}
			}
		}
		return null;
	};


    /**
     * Find index of first item matching predicate in items.
     * @param predicate function(item) that must return true if the item match the predicate
     * @param items The array of items to search
     * @return -1 if not found or index of found item otherwise.
     */
    var findIndex = function(predicate,items) {
        for(var i=0;i<items.length;i++) {
            if(predicate(items[i])) {
                return i;
            }
        }
        return -1;
    };

    /**
     * Similar to findIndex but return the found item or null if not found.
     * @see findIndex
     */
    var find = function(predicate,items) {
        var index = findIndex(predicate,items);
        return index==-1 ? null : items[index];
    };

    /**
     * Return a predicate function(item) that take an object as parameter and return true if
     * item[prop]==value
     * @param prop The property of object to test
     * @param value The value to test
     */
    var propEq = function(prop,value) {
        return function(item) {
            return item[prop+'']==value;
        };
    };

    /**
     * Return a predicate function(item) that take an item as parameter and return true if
     * item==value
     * @param value The value to test
     */
    var valEq = function(value) {
        return function(item) {
            return item==value;
        };
    };

    /**
     * Takes a list of predicates function(item) and returns a predicate function(item) that returns true
     * if all predicates return true. Equivalent to saying predicate1(item) && ... predicateN(item).
     */
    var allPass = function(predicates) {
        return function(item) {
            for(var i=0;i<predicates.length;i++) {
                if(!predicates[i](item)) {
                    return false;
                }
            }

            return true;
        };
    };

    /**
     * Takes a list of predicates function(item) and returns a predicate function(item) that returns true
     * if any of the predicates return true. Equivalent to saying predicate1(item) || ... predicateN(item).
     */
    var anyPass = function(predicates) {
        return function(item) {
            for(var i=0;i<predicates.length;i++) {
                if(predicates[i](item)) {
                    return true;
                }
            }

            return false;
        };
    };

    /**
     * Convert an array of objects into an association table (object) indexed by the values contained in item[n].prop.
     * If prop is stricly null, association table will take item[n] as key
     */
    var toAssoc = function(prop,items) {
        var assoc = {};
        if(prop===null) {
            for(var i=0;i<items.length;i++) {
                assoc[items[i]] = items[i];
            }
        }else if (items!==null){
            for(var i=0;i<items.length;i++) {
                assoc[items[i][prop]] = items[i];
            }
        }
        return assoc;
    };

	var searchFiles = function(filterString,files) {
		if(filterString=='') {
			return true;
		}
		if(!files) {
			return false;
		}
		for(var i=0;i<files.length;i++) {
			if((files[i].name+'').toUpperCase().indexOf(filterString)!=-1) {
				return true;
			}
		}
		return false;
	};

	var searchComments = function(filterString,commentSummary) {
		if(filterString=='') {
			return true;
		}
		if(!commentSummary) {
			return false;
		}
		if(commentSummary.last  && (commentSummary.last.m+'').toUpperCase().indexOf(filterString)!=-1) {
			return true;
		}

		return false;
	};

	var bindStrParams = function(str,params) {
		for(var param in params) {
			if(params.hasOwnProperty(param)) {
				str = str.replace(new RegExp('{'+param+'}','g'),params[param]);
			}
		}

		return str;
	};

    var linkTypes = {
        'int': true,
        'double': true,
        'url' : true,
        'shorttext': true,
        'longtext': true,
        'mediumtext' : true,
		'date': true,		
		'condenumforeign': true,
        'condtextforeign': true,
        'enumforeign': true,
		'autonumber': true,
        'email': true,
		'formula': true
    };

     var lookupTypes = {
        'boolean': true,
        'int': true,
        'double': true,
        'url' : true,
        'shorttext': true,
        'mediumtext' : true,
        'longtext': true,
        'date': true,
        'link': true,
        'files': true,
		'enumforeign': true,
        'condenumforeign': true,
		'condtextforeign': true,
		'autonumber': true,
        'email': true,
        'formula': true,
		'phone': true,
		'form': true,
		'autodoc': true,
    };

    var enumForeignTypes = linkTypes;

    var formulaTypes = {
        'boolean': true,
        'int': true,
        'double': true,
        'url' : true,
        'shorttext': true,
        'mediumtext' : true,
        'longtext': true,
        'date': true,
        'link': true,
        'lookup': true,
        'files': true,
        'enumforeign': true,
        'condenumforeign': true,
        'condtextforeign': true,
        'autonumber': true,
        'email': true,
        'formula': true,
        'form': true
    };

    var cardTypes = {
        "boolean":true,
        "int":true,
        "double":true,
        "url":true,
        "shorttext":true,
        "mediumtext":true,
        "longtext":true,
        "date":true,
		"link":true,
        "formula":true,
		"enumforeign":true,
        "condenumforeign":true,
		"condtextforeign":true,
        "email": true
    };

    var cardTitleTypes = {
        "boolean":true,
        "int":true,
        "double":true,
        "url":true,
        "shorttext":true,
        "mediumtext":true,
        "longtext":true,
        "date":true,
		"enumforeign":true,
        "condenumforeign":true,
		"condtextforeign":true,
		"lookup":true,
		"link":true,
        "formula" : true,
		"autonumber": true,
        "email": true,
        "lastmodified": true
    };

    var calendarTypes = {
        "boolean":true,
        "int":true,
        "double":true,
        "url":true,
        "shorttext":true,
        "mediumtext":true,
        "date":true,
		"enumforeign":true,
        "condenumforeign":true,
		"condtextforeign":true,
        "longtext": true,
        "link": true,
        "lookup": true,
        "formula": true,
		"autonumber": true,
        "email": true,
        "lastmodified": true
    };

    var simpleTypes = [
        "boolean",
        "int",
        "double",
        "url",
        "shorttext",
        "mediumtext",
        "longtext",
        "date",
        "autonumber",
        "email"
	];
	
	var colorTypes = {
		"color": true,
		"colortext": true
	};

    /**
     * Represents the current type conversions supported by FormPro at the moment.
     * The left side represents the source types.The right side represents the possible destination types.
     * Note: For simplicity you may include the source type in the destination types.
     */
    var typeConversions = {
        "boolean": simpleTypes,
        "int": simpleTypes,
        "double": simpleTypes,
        "url": simpleTypes,
        "shorttext": simpleTypes,
        "mediumtext": simpleTypes,
        "longtext": simpleTypes,
        "date": simpleTypes,
        "files": [],
        "comments": [],
        "activity": [],
        "enumforeign": simpleTypes,
        "link": [],
        "lookup": [],
        "color": ["shortext","mediumtext","longtext"],
        "formula": [],
        "autonumber": simpleTypes,
        "email": simpleTypes
    };

    var numberTypes = {
        'int': true,
        'double': true,
		'autonumber': true
	};

    var jsonTypes = {
        link: true,
        lookup: true,
        files: true,
        comments: true,
        activity: true,
        date: true
    };

    var unCancelableTypes = {
        comments: true,
        activity: true,
        lastmodified: true
    };

    var readOnlyTypes = {
        formula: true,
        lookup: true,
        autonumber: true,
        lastmodified: true,
        form: true,
    };

    var isValueFile = function(value) {
        return value && value.name && value.preview && value.url;
    };

    var hasLinkToCurrent = function(currentCategoryId,category) {
        for(var i=0;i<category.fields.length;i++) {
            if(category.fields[i].type=="link" && category.fields[i].link.category.id==currentCategoryId) {
                return true;
            }
        }
        return false;
    };

    var findDependingLookups = function(fields,linkIndex) {		
		var targetLinkId = fields[linkIndex].link.id;
        var lookups = [];
        for(var i=0;i<fields.length;i++) {
            if(fields[i].type=='lookup' && fields[i].lookup.refLink.id==targetLinkId) {
                lookups.push(i);
            }
        }

        return lookups;
    };

    var linkHasLookup = function(fields,field) {
        for(var i=0;i<fields.length;i++) {
            var f = fields[i];
            if(f.type=="lookup" && f.lookup.refLink.field_id==field.id) {
                return true;
            }
        }
        return false;
    };


    /**
     * Extract field ids referenced in ast
     * Return an object with field ids as keys and true as values
     */
    var extractAstFields = function(ast) {
        var fieldIds = {};
        extractAstParamsFields([ast],fieldIds);
        return fieldIds;
    };

    var extractAstParamsFields = function(params,fieldIds) {
        params.forEach(function(param) {
            if(param.type == 'fieldValue') {
                fieldIds[param.fieldId+''] = true;
            }else if(param.type == 'function') {
                extractAstParamsFields(param.params,fieldIds);
            }
        });
    };

    //find depending formulas
    var fieldHasFormula = function(fields,field) {
        var formulaFields = fields.filter(function(f) {
            return f.type=="formula";
        });
        if(formulaFields.length==0) {
            return false;
        }

        for(var i=0;i<formulaFields.length;i++) {
            if(!formulaFields[i].formula.ast) {
                continue;
            }
            if(FormPro.extractAstFields(formulaFields[i].formula.ast)[field.id+'']) {
                return true;
            }
        }

        return false;
    };

    /**
     * Transfer any view modified locally (not synced to server) from oldForm to newForm.
     * Note that newForm is modified by this function
     * @return The new (modified) form
     */
    var transferModifiedViewsInForm = function(oldForm,newForm) {

        var oldCategories = toAssoc('id',oldForm.categories);
        for(var i=0;i<newForm.categories.length;i++) {
            if(oldCategories[newForm.categories[i].id]) {
                newForm.categories[i] = transferModifiedViews(oldCategories[newForm.categories[i].id],newForm.categories[i]);
            }
        }
        return newForm;

    };

    var transferModifiedViews = function(oldCategory,newCategory) {
        var isModified = function(view) {
            return view._modified;
        };

        if (!oldCategory)
        	return newCategory;

        var modifiedViews = toAssoc('id',oldCategory.views.filter(isModified));

        if(modifiedViews.length==0) {
            return newCategory;
        }

        for(var i=0;i<newCategory.views.length;i++) {
            if(modifiedViews[newCategory.views[i].id]) {
                newCategory.views[i] = modifiedViews[newCategory.views[i].id];
            }
        }

        return newCategory;
    };

    var ensureModifiedViewsValid = function(category) {
        if(!category.fields) {
            return category;
        }

        var fields = FormPro.includeHiddenFields(category);
        for(var i=0;i<category.views.length;i++) {
            if(category.views[i]._modified) {
                category.views[i] = filterInvalidFieldsInView(fields,category.views[i]);
            }
        }
        return category;
    };


    var filterInvalidFieldsInView = function(fields,view) {
        fields = toAssoc('id',fields);
        var processField = function(o,key) {
            if(!fields[o[key]]) {
                o[key] = null;
            }
        };
        ['hz_field_id','title_field_id'].forEach(processField.bind(null,view.card));
        ['display_field_id','start_field_id','end_field_id','co_field_id'].forEach(processField.bind(null,view.calendar));

        if(!view.filterGroup || !view.filterGroup.filters) {
            return view;
        }

        view.filterGroup.filters = view.filterGroup.filters.filter(function(filter) {
            return fields[filter.field_id];
        });
        return view;
	};

    /**
     * Compare two array, return true if they are the same according to the compareFunc function passed, false otherwise.
     * @param compareFunc Function that compare two array items function(itemA,itemB). Must return true if the two items
     * are the same, false otherwise.
     * @param a First array
     * @param b Second array
     */
    var compareArrays = function(compareFunc,a,b) {
        if(a.length!=b.length) {
            return false;
        }

        for(var i=0;i<a.length;i++) {
            if(a[i]!==b[i] && !compareFunc(a[i],b[i])) {
                return false;
            }
        }

        return true;
    };

    var formatDate = function(displayFormat,dataFormat,value) {
        if(!value || value===null || value==='' || value==='0000-00-00') {
            return '';
        }

        return moment(value,dataFormat).format(displayFormat);
    };

    var formatDateValue = function(dateValue){
        //Redirect to object property if the date is stored in an object
        return (dateValue != null && typeof dateValue === "object") ? dateValue.value : dateValue;
    };

    var numeralFormat = function(numFormat,value,numLang) {
        if(value===null || value==="" || Number.isNaN(value)) {
            return '';
        }

        //Support other currencies in case of base field using other currencies
        if(numLang == "fr"){
            var tempValue = numeral(value).format(numFormat);
            return tempValue.replace('$','€');
        }
        else if(numLang == "en-gb"){
            var tempValue = numeral(value).format(numFormat);
            return tempValue.replace('$','£');
        }
        return numeral(value).format(numFormat);
    };

    var defaultDateFormat = {
        display: "YYYY-MM-DD",
        data: "YYYY-MM-DD"
    };

    var filePickProp = function(files,fileSeparator,prop) {
        if(!files || !files.length) {
            return '';
        }
        if(typeof fileSeparator==="undefined" || fileSeparator===null) {
            fileSeparator = ", ";
        }
        return files.map(function(file) {
            return file[prop];
        }).join(fileSeparator);
    };

    var fileCount = function(files) {
        var nb = files && files.length ? files.length : 0;
        return nb +' ' + TLang['Attachments'];
    };

    var linkFiles = function(links) {
        var files = [];
        if(!links || !links.length) {
            return files;
        }

        for(var i=0;i<links.length;i++) {
            if(links[i].value && links[i].value.length) {
                files = files.concat(links[i].value);
            }
        }
        return files;
    };

    var linkValueAsText = function(targetField,value,props) {
        return valueAsText($.extend({},targetField,{value: value}),props);
    };

    var getLinkTargetField = function(field) {
       var targetField = field.type=="link" ? field.link.field : field.lookup.resolved.field;
       return $.extend({},targetField);
   };

    var valueAsText = function(field,props) {
        var defaultProps = {
            dateFormat: defaultDateFormat,
            fileDisplay : "count", //"urls" (deprecated) or any prop in file object (ex: name,url,etc...)
            linkSeparator: ", ",
            fileSeparator: ", "
        };

        props = $.extend(defaultProps,props);

        if (field == undefined) {
            return '';
        }
        else if(field.type=="boolean") {
            return field.value==1 ? "checked" : "unchecked";
        }
        else if(field.type=="date") {
			var value;
			var displayFormat = field.dateFormat ? field.dateFormat : props.dateFormat.display;
			var displayTime = field.timeAndDate == 1 && field.value && !field.value.isAllDay && !props.hideTime;
			displayFormat = displayTime ? displayFormat+" HH:mm" : displayFormat;
			var dataFormat = displayTime ? props.dateFormat.data+" HH:mm" : props.dateFormat.data;

            if(field.value && typeof field.value == "object" && field.value !== null){
                value = field.value.value;
            }
            else if(typeof field.value === "string"){
                value = field.value;
			}
			
			if(moment(value,displayFormat,true).isValid()){
				return value;
			}

			//issue #2873 : fix for pivot table not removing hours for not-date-and-time-fields
			if(moment(value,"YYYY-MM-DD HH:mm",true)){
				return formatDate(displayFormat,"YYYY-MM-DD HH:mm",value);
			}
			else{
				return formatDate(displayFormat,dataFormat,value);
			}
        }
        else if(isFieldTypeNumeric(field.type)) {
            if(field.value===null || field.value==='') {
                return '';
            }
            if(field.numFormat) {
                return numeralFormat(calculationModeFormat(field.calculationMode, field.numFormat),field.value,field.numLang);
            }
            return (1*field.value)+'';
        }
        else if(field.type=="files") {
            if(props.fileDisplay=="count") {
                return fileCount(field.value);
            }
            var fileDisplay = props.fileDisplay;
            if(fileDisplay==="urls") {
                fileDisplay = "url";
            }
            return filePickProp(field.value,props.fileSeparator,fileDisplay);
        }
        else if(field.type=="comments" || field.type=="activity") {
            return field.value && field.value.last ? field.value.last.m : '';
        }
        else if(field.type=="link" || field.type=="lookup") {
            var nb=0;
            var targetField = getLinkTargetField(field);
            if(targetField.type=="files") {
                return valueAsText($.extend({},targetField,{value: linkFiles(field.value)}),props);
            }

            if(!field.value || field.value.length==0) {
                return '';
            }

            try {
                return field.value.map(function(link) { return linkValueAsText(targetField,link.value,props); }).join(props.linkSeparator);
            }catch(e) {
                //Juliend: saw an error one time here but haven't been able to reproduce it so far
                console.log("juliend Card.valueAsText exception field=",field);
                console.log("juliend Card.valueAsText exception e=",e);
                return '';
            }
        }
        else if(field.type=="formula") {
            return valueAsText($.extend({},field,{type: field.formula.outputType}),props);
        }
        else if(field.type=="encrypted") {
            return field.encrypted && field.encrypted.decrypted ? 
                field.value : 
                (field.value ? "********" : "");
        }
        else {
            return field.value===null ? '' : field.value+'';
        }
    };

    var multipleSelect = function(params) {
        var $elem = $("<div>",{
            "class": "FpMultipleSelect"
        });

        params.options.forEach(function(option) {
            var $option = $("<div>",{
                "class" : "FpMultipleSelectOption" + (option.selected ? " selected" : ""),
                "text" : option.text
            });
            $option.attr("data-fp-value",
                (typeof option.value !== "undefined" && option.value!==null) ? option.value: option.text);

            if(option.color) {
                $option.css("background-color",option.color);
                $option.css("color",colorIsLight(option.color) ? "#000" : "#FFF");
            }
            $elem.append($option);
        });

        $elem.click(function(event) {
            if(event.target==this) {
                return;
            }

            var $target = $(event.target);
            if(event.metaKey || event.ctrlKey) {
                $target.toggleClass("selected");
            }else {
                $elem.find(".FpMultipleSelectOption.selected").removeClass("selected");
                $target.addClass("selected");
            }

            if(params.onChange) {

                var selectedValues = [];
                $elem.find(".FpMultipleSelectOption.selected").each(function(index,option) {
                    selectedValues.push($(option).attr("data-fp-value"));
                });
                params.onChange(selectedValues);
            }

        });

        return $elem;
    };

    var fieldHasColors = function(field) {
		if (typeof field == "undefined" || !field) {
			return false;
		}
		if (typeof field.enumColors == "undefined" || !field.enumColors)
			return false;
        return field.enumColors.displayColors && field.enumColors.values.length;
    };

    /**
     * Convert characters in string that are not compatible with css class name conventions.
     * @return the new string
     */
    var strToCssClass = function(str) {
        return str.replace(/\W/g, '_');
    };

    var addNewOption = function(category,field_id,value,options) {
        var defaults = {
            onOk: null,
            onError: null,
            tab_id: null
        };
        options = $.extend(defaults,options);
        var field = findById(category.fields,field_id);
        if(!field) {
            return;
        }
        if(Array.isArray(value)) {
            value.forEach(function(value) {
                field.enumColors.values.push({value: value});
            });
        } else {
            field.enumColors.values.push({value: value});
        }

				addNewEnumOption(field_id,value,options);
    };

	var addNewMask = function(field,value,options){
		field.masks.push(value);
		addNewEnumOption(field.id,value,options);
	};

	var addNewEnumOption = function(field_id,value,options){
		$.ajax({
            type: "POST",
            dataType: "json",
            url     : apiEndpointUrl + "?addCarnetFormEnumOption",
            data: {
                indexVNB        : indexVNB,
                session         : sessionNB,
                live            : 'yes',
                newDashboard    : "addCarnetFormEnumOption",
                field_id        : field_id,
                values          : Array.isArray(value) ? value : [value],
                tab_id          : options.tab_id
            },
            success: function(donnees) {
                if (donnees=='reload') {
                    windowReload();
                }

                if(donnees && donnees.status=="ok") {
                    if(options.onOk) {
                        options.onOk(donnees);
                    }
                }else if(options.onError) {
                    options.onError(donnees.status);
                }
            },
            error: function() {
                if(options.onError) {
                    options.onError();
                }
            },
            async: true
        });
	};

    var convertUtilisateur = function(utilisateur) {
        var formatUserName = function (utilisateur_code,nom,prenom) {
            if(!nom && !prenom) {
                return utilisateur_code;
            }
            if(!nom) {
                return prenom;
            }
            if(!prenom) {
                return nom;
            }

            return prenom +' ' + nom;
        };
        return {
            code: utilisateur.code,
            sstamp: utilisateur.imgStamp,
            name: formatUserName(utilisateur.code,utilisateur.nom,utilisateur.prenom)
        };
    };

	var findLinkColorField = function(fields){
		var i, colorField = null;
		for (i = 0; i < fields.length; i++) {
			if (fields[i].type == "color") {
				colorField = fields[i];
				break;
			}  
		}
		
		if(colorField === null){
			for (i = 0; i < fields.length; i++) {
				if (fields[i].enumColors) {
					colorField = fields[i];
					break;
				}
			}
		}
		return colorField;
	};

    /**
     * Find value in enum color and return corresponding color or false if it was not found
     * @param  {string} value      value to lookup in enumColor
     * @param  {array|object} enumColors An array or object. If it is an object, it should have
     * keys be lower case enum value and its value be the enum color value. The enum color value
     * has the following format: {value,color}
	 * @param  {boolean} isText if true, then search for text color
     * @return {string}            Any valid HTML color.
     * @see  enumColorValuesToObj
     */
    var findEnumColor = function(value,enumColors,isText) {
        var enumValue = findEnumColorValue(value,enumColors);
        if(!enumValue) {
            return false;
        }
        return (isText ? enumValue.colortext : enumValue.color) || false;
    };

    var findEnumColorValue = function(value,enumColors) {
        if (enumColors === undefined || enumColors == null) {
            return null;
        }
        var matchingValue = toEnumColorMatchingValue(value);
        if (matchingValue===null) {
            return null;
        }
        if(Array.isArray(enumColors)) {
            for (var i = 0; i < enumColors.length; i++) {
                var enumMatchingValue = toEnumColorMatchingValue(enumColors[i].value);
                if(enumMatchingValue===null) {
                    continue;
                }

                if (matchingValue === enumMatchingValue ) {
                    return enumColors[i];
                }
            }
            return null;
        }

        return enumColors[matchingValue] || null;
    };


    /**
     * Convert enumColors values from an array to an obj with keys being enumColorValue.value.toLowerCase().
     * @param  {obj} enumColors enumColors such as found in field
     * {
     *     displayColors: <1|0>,
     *     strict:<1|0>,
     *     values: [{value:"Some string",color:"#FE2458"},...]
     * }
     * @return {object}            generated object
     */
    var enumColorValuesToObj = function(enumColors) {
        var values=enumColors.values, obj = {},matchingValue;
        for(var i=0;i<values.length;i++) {
            if(values[i] && (matchingValue=toEnumColorMatchingValue(values[i].value)) ) {
                obj[matchingValue] = values[i];
            }
        }
        return obj;
    };

    /**
     * Convert a value to a value suitable to be matched against an enum color value
     * @param  {any}  value Original value
     * @return {string}       A string value or null if value could not be converted.
     */
    var toEnumColorMatchingValue = function(value) {
        if(typeof value !== "string") {
            return null;
        }
        return value.toLowerCase();
    };

    var toBoolean = function(value) {
        return (!value || value==="0" || value==="false") ? false : true;
    };

    /**
     * Compute hash map of id to index for array items.
     * items must contain objet with an .id property
     * Example:
     * var items = [{id: "zezez",value: "toto"},{id: 123,value: "titi"}]
     * var idMap = FormPro.idToIndex(items);
     * console.log(idMap);
     * Output:
     * {"zezez": 0,"123": 1}
     */
    var idToIndex = function(items) {
        var result = {};
		if (items == null)
			return result;
        for(var i=0;i<items.length;i++) {
            items[i] && (result[items[i].id] = i);
        }
        return result;
    };

    var lastTmpRowIdCount = 1;
    var generateTmpRowId = function() {
        lastTmpRowIdCount += 1;
        return "tmp" + lastTmpRowIdCount;
    };
    var generateTmpFilterId = generateTmpRowId;

    var isTmpRowId = function(row_id) {
        return (typeof row_id === "string") && row_id.indexOf('tmp') === 0;
    };

    var linkWithJustRowId = function(link) {
        return {row_id: link.row_id};
    };

    var enumColorsProp = function(enumColors) {
        return {
            values: enumColors.values.slice(0),
            strict: enumColors.strict,
            displayColors: enumColors.displayColors,
        };
    };

    var fieldProp = function(field) {
        return {
            id: field.id,
            type: field.type,
            name: field.name,
			code: field.code,
			fixed_code: field.fixed_code,
			buttonText: (field.type == "url" || field.type == "autodoc" || field.type == "files" || field.formula && field.formula.ast.name == "CONCAT_URL") ? field.buttonText : null,
			required: field.required==1,
            numFormat: field.numformat,
            numLang: field.numlang,
            defaultDay: field.defaultDay,
			defaultValueConfig: field.defaultValueConfig,
            description: field.description,
            notifSubscribe: NotifSubscribe.getCopy(field.notifSubscribe),
            textFormat: field.textFormat,
			codeScan: field.codeScan,
			numericKeyBoard: field.numericKeyBoard,
            enumColors : field.enumColors? enumColorsProp(field.enumColors) : null,
            condEnumColors: field.condEnumColors ? mapObject(enumColorsProp,field.condEnumColors) : null,
            colNb: field.mobSmallColNb,
			applyColorGroup: field.applyColorGroup,
            enumForeign: field.enumForeign ? $.extend({},field.enumForeign) : null,
            condEnumForeign: field.condEnumForeign ? $.extend({},field.condEnumForeign) : null,
            condTextForeign: field.condTextForeign ? $.extend({},field.condTextForeign) : null,
            link: field.link ? $.extend(copyLinkInfoCommon(field.link),{
                selection: field.link.selection ? $.extend({},field.link.selection) : null,
            }) : null,
            lookup: field.lookup ? $.extend(copyLinkInfoCommon(field.lookup),{
                refLink: $.extend({},field.lookup.refLink),
                resolved: copyLinkInfoCommon(field.lookup.resolved),
                includeInRowEdit: field.lookup.includeInRowEdit,
                presentation: field.lookup.presentation,
                isAllDay: field.lookup.isAllDay,
            }) : null,
            form: field.form ? $.extend({},field.form) : null,
            formula: field.formula ? $.extend({},field.formula) : null,
			group_id: field.group_id,
			linkPresentation: (field.type == "link") ? field.linkPresentation : null,
            activePresentation: (field.type == "files") ? field.activePresentation : null,
			autodocTemplateId: (field.type == "autodoc") ? field.autodocTemplateId : null,
			autodocFieldId: (field.type == "autodoc") ? field.autodocFieldId : null,
			autodocSaveFieldId: (field.type == "autodoc") ? field.autodocSaveFieldId : null,
			isPdfExport: (field.type == "autodoc") ? field.isPdfExport : null,
			timeAndDate: (field.type === "date" || field.type === "formula") ? field.timeAndDate : null,
			dateFormat: (field.type === "date" || field.type === "formula") ? field.dateFormat : null,
            readOnly: field.readOnly,
			filesAuthRequired: field.filesAuthRequired,
			attachementSingleFile: field.attachementSingleFile,
            encrypted: field.encrypted ? $.extend({},field.encrypted) : null,
            sysFunc: field.sysFunc,
			conditionalVisibility: field.conditionalVisibility,
        };
    };

    var fieldWithValueProp = function(rowIndex,field) {
        return $.extend(fieldProp(field),field.values ? {value: field.values[rowIndex].value} : undefined);
    };

    var copyLinkInfoCommon = function(linkInfo) {
        return $.extend({},linkInfo,{
            form: $.extend({},linkInfo.form),
            category: $.extend({},linkInfo.category),
            field: fieldProp(linkInfo.field),
        });
    };



    /**
     * detect if a field value contains time+date.
     * @param  field
     */
    var hasTimeAndDate = function(field) {
        // todo add timeAndDate info to formula's output info
        return (field.type=="date" && field.timeAndDate==1) || field.type=="lastmodified";
    };

    var colorIsLight = function(colorHex) {
		//console.log('colorHex:'+colorHex);
		var a;
		if (colorHex) {
            var red = parseInt(colorHex.substr(1,2),16);
            var green = parseInt(colorHex.substr(3,2),16);
            var blue = parseInt(colorHex.substr(5,2),16);
			a = (0.299 * red + 0.587 * green + 0.114 * blue) / 255;
			//console.log('red:'+red);
			//console.log('green:'+green);
			//console.log('blue:'+blue);
		}
		else{
			a = 1;
        }
		//console.log('a:'+a);
        return (a > 0.73);
    };

    var convertBitsToBytes = function(size) {
        // WARNING : does return a string
        if(typeof size != "number"){
            return "0 " + TLang['Size.Bytes'];
        }

        var typesize = 0;
        var newSize = size;
        while(newSize > 1024 && typesize < 3){
            newSize = newSize/1024;
            typesize++;
        }

        switch(typesize){
            case 0:
                newSize = newSize + " " + TLang['Size.Bytes'];
                break;
            case 1:
                filesize = newSize.toFixed(1);
                newSize = filesize + " " + TLang['Size.KiloBytes'];
                break;
            case 2:
                filesize = newSize.toFixed(1);
                newSize = filesize + " " + TLang['Size.MegaBytes'];
                break;
            default:
                filesize = newSize.toFixed(2);
                newSize = filesize + " " + TLang['Size.GigaBytes'];
                break;
        }
        return newSize;
    };

    var activateSSF = function(category) {
        return enableSSF;
    };

    var getLazyLoadingMaxRows = function(category) {
        return enableLazyLoading && category.totalRowCount > maxRowCountBeforeSSF ? maxRowCountBeforeSSF : false;
    };

    var enableFilterOnKeyUp = function(category) {
        return category.totalRowCount <= maxRowCountBeforeFilterOnKeyUp;
    };


    var replaceCategoryData = function(oldCategory,newCategory) {
        var fieldIndexes = idToIndex(newCategory.fields);
        var i;
        if (oldCategory.fields) for(i=0;i<oldCategory.fields.length;i++) {
            var oldField = oldCategory.fields[i];
            var index = fieldIndexes[oldField.id];
            if(typeof index === 'undefined') {
                return false;
            }
            var newField = newCategory.fields[index];
            if(oldField.type!==newField.type) {
                return false;
            }
            replaceArrayData(oldField.values,newField.values);
        }

        var prop,oldRowInfos=oldCategory.rowInfos,newRowInfos=newCategory.rowInfos;
        for (prop in oldRowInfos) {
            if (oldRowInfos.hasOwnProperty(prop)) {
                delete oldRowInfos[prop];
            }
        }
        for (prop in newRowInfos) {
            if (newRowInfos.hasOwnProperty(prop) && typeof newRowInfos[prop] !== "undefined") {
                oldRowInfos[prop] = newRowInfos[prop];
            }
        }

        return true;
    };

    var replaceArrayData = function(oldArray,newArray) {
        var i;
        for(i=0;i<oldArray.length && i < newArray.length;i++) {
            oldArray[i] = newArray[i];
        }

        if(oldArray.length == newArray.length) {
            return;
        }

        if(oldArray.length < newArray.length) {
            for(;i < newArray.length;i++) {
                oldArray.push(newArray[i]);
            }
            return;
        }

        // oldArray.length > newArray.length
        oldArray.length = newArray.length;
    };

    /**
     * Utility function to execute code based on a decision table.
     * Any sequence of {match,result} pair is passed in arguments. Returns result's of the first match matching record.
     * Any property missing from match is ignored for convenience. Therefore a missing property in a match is similar to
     * a match any wildcard "*".
     *
     * Examples:
     * var result = caseOf({a: true,b:false},
        {match: {a:true,b: true}
        ,result:  "result1"},

        {match: {a:true,b: false}
        ,result:  "result2"},

        {match: {}
        ,result:  "result3"}
    );
    // result="result2"

    var result = caseOf({a: false,b:true},
        {match: {a:true}
        ,result:  "result1"},

        {match: {b: false}
        ,result:  "result2"},

        {match: {}
        ,result:  "result3"}
    );
    // result="result3"

    var result = caseOf({a: false,b:true},
        {match: {a:true}
        ,result:  "result1"},

        {match: {b: false}
        ,result:  "result2"}
    );
    // an error is logged on the console and caseOf returns undefined
    // result=undefined
     * @param  {object} record object to match
     * @param {object} match One or more matches {match: {...},result: {...}}
     * @return        result of first matching match.
     */
    var caseOf = function(record) {
        var matches = Array.prototype.slice.call(arguments, 1);

        var testMatch = function(match) {
            var keys = Object.keys(match);
            for(var i=0;i<keys.length;i++) {
                if(match[ keys[i] ]!==record[ keys[i] ]) {
                    return false;
                }
            }
            return true;
        };
        for(var i=0;i<matches.length;i++) {
            if(testMatch(matches[i].match)) {
                return matches[i].result;
            }
        }

        console.log("Warning: caseOf did not match anything on record=",record);
        return undefined;
    };


    var fillArray = function(value,count) {
        array = [];
        while(count) array[--count]= value;
        return array;
    };

    var lazyLoader = function() {
        var timeout , queue , options , isFetching, stamp = 0, defaults = {timeout: 100} ;

        var reset = function() {
            if(timeout) {
                clearTimeout(timeout);
            }
            stamp++;
            isFetching = false;
            options = null;
            timeout = null;
            queue = [{fieldsToLoad: {},rowsToLoad: {}}];
            fieldsToLoad = {};
            rowsToLoad = {};
        };

        var init = function(opt) {
            reset();
            options = $.extend({},defaults,opt);
        };

        var isInitialized = function() {
            return options!==null;
        };

        var push = function(field,row) {
            var current = queue[queue.length-1];
            current.fieldsToLoad[field.id] = field.data;
            current.rowsToLoad[row.id] = row.data;
            if(isFetching) {
                return;
            }
            if(timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(fetch,options.timeout);
        };

        var fetch = function() {
            if(isFetching) {
                return;
            }
            isFetching = true;
            var current = queue.shift();
            var field_ids = Object.keys(current.fieldsToLoad);
            var row_ids = Object.keys(current.rowsToLoad);
            queue.push({fieldsToLoad: {},rowsToLoad: {}});

            var localStamp = stamp;
            $.ajax({
                type: "POST",
                dataType: "json",
                url     : apiEndpointUrl + "?getCarnetFormValueSubset",
                data: {
                    indexVNB        : indexVNB,
                    session         : sessionNB,
                    timestamp       : getTTCtimestamp(),
                    live            : 'yes',
                    newDashboard    : "getCarnetFormValueSubset",
                    field_ids       : field_ids,
                    row_ids         : row_ids,
                    tab_id          : options.tab_id,
                    encryptedFieldPasswords: getEncryptedFieldPasswords(),
                },
                success: function(donnees) {
                    if(localStamp!=stamp) {
                        return;
                    }
                    if(donnees && donnees.status=="ok") {
                        processRows(field_ids,row_ids,current.fieldsToLoad,current.rowsToLoad,donnees.rows);
                    }
                },
                complete: function() {
                    if(localStamp!=stamp) {
                        return;
                    }
                    isFetching = false;
                    if(queue.length > 1 || !isObjectEmpty(queue[0].fieldsToLoad) ) {
                        if(timeout) {
                            clearTimeout(timeout);
                        }
                        timeout = setTimeout(fetch,options.timeout);
                    }
                }
            });
        };


        var processRows = function(field_ids,row_ids,fieldsToLoad,rowsToLoad,rows) {
            var fieldIdToIndex = idToIndex(options.fields || options.category.fields);
            saveValueSubset(options.category,field_ids,row_ids,rows,fieldIdToIndex,options.fields);
            if(!options.onLoad) {
                return;
            }
            var fields = field_ids.map(function(field_id) {
                return {
                    id: field_id,
                    index: fieldIdToIndex[field_id],
                    data: fieldsToLoad[field_id]
                };
            });
            var rows = row_ids.map(function(row_id,index) {
                return {
                    id: row_id,
                    data: rowsToLoad[row_id],
                    values: rows[index]
                };
            });
            options.onLoad(fields,rows);
        };

        var saveValueSubset = function(category,field_ids,row_ids,rows,fieldIdToIndex,fields) {
            fields = fields || category.fields;
            if(!fieldIdToIndex) {
                fieldIdToIndex = idToIndex(fields);
            }
            for(var i=0;i<field_ids.length;i++) {
                var field = fields[ fieldIdToIndex[ field_ids[i] ] ];
                if(!field.values) {
                    field.values = [];
                }
                for(var j=0;j< rows.length;j++) {
                		if (typeof category.rowInfos[row_ids[j]] == "undefined") {
                			continue;
                		}
                    field.values[ category.rowInfos[row_ids[j]].index ] =
                        {id: row_ids[j],value: rows[j][i]};
                }
            }

            equalizeValuesLengths(fields);
        };

        reset();
        return {
            push: push,
            reset: reset,
            init: init,
            isInitialized: isInitialized
        };
    };


    var equalizeValuesLengths = function(fields) {
        var maxValueLength = fields.reduce(function(acc,field) {
            return field.values.length > acc ? field.values.length : acc;
        },0);


        fields.forEach(function(field) {
            if(field.values.length!==maxValueLength) {
                field.values.length = maxValueLength;
            }
        });
    };


    var isObjectEmpty = function(obj) {
        for (var key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                return false;
            }
        }

        return true;
    };

    var toIdSet = function(array) {
        var set = {};
        for(var i=0;i<array.length;i++) {
            set[array[i].id] = true;
        }
        return set;
    };

    var toSet = function(array) {
        var set = {};
        for(var i=0;i<array.length;i++) {
            set[array[i]] = true;
        }
        return set;
    };


    var findKeyInObject = function(predicate,obj) {
        for(var key in obj) {
            if(obj.hasOwnProperty(key) && predicate(obj[key])) {
                return key;
            }
        }
        return null;
    };

     var objectHasValue = function(obj,value,strict) {
        if(strict) {
            for(var key in obj) {
                if(obj.hasOwnProperty(key) && obj[key] === value) {
                    return true;
                }
            }
            return false;
        }
        for(var key in obj) {
            if(obj.hasOwnProperty(key) && obj[key] == value) {
                return true;
            }
        }
        return false;
    };

    var filterObject = function(predicate,obj) {
        var newObj = {};
        for(var key in obj) {
            if(obj.hasOwnProperty(key) && predicate(obj[key])) {
                newObj[key] = obj[key];
            }
        }

        return newObj;
    };

     var mapObjectToArray = function(f,obj) {
        var array = [];
        for(var key in obj) {
            if(obj.hasOwnProperty(key)) {
                array.push(f(obj[key],key));
            }
        }

        return array;
    };

    var mapObject = function(f,obj) {
        var newObj = [];
        for(var key in obj) {
            if(obj.hasOwnProperty(key)) {
                newObj[key] = f(obj[key],key);
            }
        }

        return newObj;
    };


    var safeAccess = function(obj) {
        if(obj===null || typeof obj === "undefined") {
            return {
                then: function() {
                    return safeAccess();
                },
                result: function() {
                    return undefined;
                },
                nullify: function() {
                    return null;
                },
                withDefault: function(next,def) {
                    return def;
                }
            };
        }

        var result = function(next) {
            return typeof next === "string" ? obj[next] : next(obj);
        };

        return {
            then: function(next) {
                return safeAccess(result(next));
            },
            result: result,
            nullify: function(next) {
                var ret = result(next);
                return typeof ret==="undefined" ? null : ret;
            },
            withDefault: function(next,def) {
                var ret = result(next);
                return typeof ret==="undefined" || ret===null ? def : ret;
            }
        };
    };


    var objectValues = function(obj) {
        var values = [];
        for(var key in obj) {
            if(obj.propertyIsEnumerable(key)) {
                values.push(obj[key]);
            }
        }

        return values;
    };


    var applyNewRowOrder = function(category,newOrders) {
        var newRowInfos = newOrders.map(function(newOrder) {
            var oldInfo = category.rowInfos[newOrder.id];
            if(!oldInfo) {
                return null;
            }
            return $.extend({},oldInfo,{id: newOrder.id,order: newOrder.order});
        }).filter(function(rowInfo) {
            return rowInfo!==null;
        }).sort(function(a,b) {
            return a.order*1 - b.order*1;
        });

        newRowInfos.forEach(function(rowInfo,index) {
            rowInfo.index = index;
        });

        category.fields.forEach(function(field) {
            var values = field.values,
                newValues = [];

            newValues.length = values.length;
            for(var i=0; i < newRowInfos.length; i++) {
                var oldInfo = category.rowInfos[newRowInfos[i].id];
                if(oldInfo.index >= values.length) {
                    continue;
                }
                newValues[i] = values[oldInfo.index];
            }
            field.values = newValues;
        });

        newRowInfos = newRowInfos.reduce(function(acc,info) {
            acc[info.id] = info;
            delete info.id;
            return acc;
        },{});
        category.rowInfos = newRowInfos;
    };

    var deleteFormRows = function(category,rowIds) {
        var infos = rowIds.map(function(row_id) {
            return {id: row_id, info: category.rowInfos[row_id]};
        });
        infos.sort(function(a,b) {
        		if (a.info && b.info)
        			return (a.info.index*1) - (b.info.index*1);
        		else
        			return 0;
        });
        for(var i=infos.length-1;i>=0;i--) {
            for(var j=0;j<category.fields.length;j++) {
                category.fields[j].values.splice(infos[i].info.index,1);
            }
            delete category.rowInfos[infos[i].id];
        }

        var rowInfos = objectValues(category.rowInfos).sort(function(a,b) {
            return a.index*1 - b.index*1;
        });

        for(i=infos[0].info.index;i<rowInfos.length;i++) {
            rowInfos[i].index = i;
        }

        category.totalRowCount -=  infos.length;
        category.rowInfosLength -= infos.length;
    };

    var parseNumber = function(type,value){
    	if(value===null || value==='') {
    		return {status: "ok",value: value};
    	}


    	if(type=='int') {
    		if(!/^(\+|-)?(0|[1-9]\d*)$/.test(value)) {
    			return {status: "error",info: "Integer number expected"};
    		}
    	}

    	if(type=='double') {
    		value = value.replace(',','.');
    		if(!/^(\+|-)?(0|[1-9]\d*)(\.\d+)?$/.test(value)) {
    			return {status: "error",info: "Decimal number expected"};
    		}
    	}

    	return {status: "ok",value: value};
    };

    var NotifSubscribe = (function() {

        var types = {
            NO: 0,
            YES: 1,
            ONLY_IF_UID: 2,
            ONLY_IF_UID_IN_COLUMN: 3
        };

        var getDefault = function() {
            return {
                notif: {type: types.YES},
                mail: {type: types.NO},
                message: {type: types.NO}
            };
        };

        var getTypeNames = function() {
            var keys = Object.keys(types);

            return keys.sort(function(a,b) {
                return types[a] - types[b];
            });
        };

        var getCopy = function(notifSubscribe) {
            return notifSubscribe ?
                $.extend({},notifSubscribe,{
                    notif: notifSubscribe.notif ? $.extend({},notifSubscribe.notif) : null,
                    message: notifSubscribe.message ? $.extend({},notifSubscribe.message,{
                        activityFieldSelection: 
                            notifSubscribe.message.activityFieldSelection ?
                                $.extend({},notifSubscribe.message.activityFieldSelection) : null
                    }) : null,
                    mail: notifSubscribe.mail ? $.extend({},notifSubscribe.mail) : null
                }) :
                null;
        };

        var save = function(options) {

            $.ajax({
                type: "POST",
                dataType: "json",
                url     : apiEndpointUrl + "?saveCarnetFormNotifSubscribe",
                data: options.adminOptions ?
                {
                    indexVNB        : indexVNB,
                    session         : sessionNB,
                    live            : 'yes',
                    newDashboard    : "saveCarnetFormNotifSubscribeAdmin",
                    field_id        : options.field_id,
                    notifSubscribe  : options.notifSubscribe,
                    applyToAll      : options.adminOptions.applyToAll,
                    save            : options.adminOptions.save
                } :
                {
                    indexVNB        : indexVNB,
                    session         : sessionNB,
                    live            : 'yes',
                    newDashboard    : "saveCarnetFormNotifSubscribe",
                    field_ids       : options.fields_ids,
                    row_ids         : options.row_ids,
                    notifSubscribe  : options.notifSubscribe
                },
                success: function(donnees) {
                    if (donnees=='reload') {
                        windowReload();
                    }
                    if(donnees && donnees.status=="ok") {
                        options.onOk && options.onOk(options.adminOptions ? donnees.formLastModified : undefined);
                    }else {
                        options.onError && options.onError(donnees ? donnees.status : null);
                    }
                },
                error: function() {
                    options.onError && options.onError();
                },
                async: true
            });
        };

        var getCellNotif = function(fieldDefaults,cell) {
            return $.extend(getDefault(),fieldDefaults || {},cell);
        };

        var hasNotif = function(fieldDefaults,cell) {
            var notifSubscribe = getCellNotif(fieldDefaults,cell);
            return notifSubscribe.notif.type != types.NO || notifSubscribe.message.type != types.NO ||
                notifSubscribe.mail.type != types.NO;
        };

        // exports
        return {
            types : types,
            getDefault : getDefault,
            getTypeNames: getTypeNames,
            getCopy: getCopy,
            save: save,
            hasNotif: hasNotif,
            getCellNotif: getCellNotif,
        };
    })();


    var TabType = (function() {
        var types = {
            TABLE: 1,
            PIVOT: 2,
            VIEW_SHORTCUT: 3
        };
        var getTabType = function(tab,category) {
            if(tab.view_id) {
                return types.VIEW_SHORTCUT;
            }else if(category.pivot_id) {
                return types.PIVOT;
            }else {
                return types.TABLE;
            }
        };

        return {
            types: types,
            getTabType: getTabType
        };

    })();

    var DuplicateRow =(function() {
        var duplicateRow = function(row_id,options) {
            var defaults = {
                onOk: null,
                onError: null
            };
            options = $.extend({},defaults,options);

            $.ajax({
                type: "POST",
                dataType: "json",
                url     : apiEndpointUrl + "?duplicateCarnetFormRow",
                data: {
                    indexVNB        : indexVNB,
                    session         : sessionNB,
                    live            : 'yes',
                    newDashboard    : "duplicateCarnetFormRow",
                    row_id          : row_id
                },
                success: function(donnees) {
                    if (donnees=='reload') {
                        windowReload();
                    }
                    if(donnees && donnees.status=="ok") {
                        options.onOk && options.onOk();
                    }else if(options.onError) {
                        options.onError(donnees && donnees.status);
                    }
                },
                error: function() {
                    options.onError && options.onError();
                },
                async: true
            });

        };

        return {
            duplicateRow: duplicateRow
        };
    })();

    var DefaultRow =(function() {

        var set = function(params) {
            var defaults = {
                row_id: null,
                scope: 2,
                category: null,
                view_id: null,
                onOk: null,
                onError: null
            };
            var params = $.extend(defaults,params);

            $.ajax({
                type: "POST",
                dataType: "json",
                url     : apiEndpointUrl + "?setCarnetFormDefaultRow",
                data: {
                    indexVNB        : indexVNB,
                    session         : sessionNB,
                    live            : 'yes',
                    newDashboard    : "setCarnetFormDefaultRow",
                    row_id          : params.row_id,
                    scope           : params.scope,
                    view_id         : params.view_id
                },
                success: function(donnees) {
                    if (donnees=='reload') {
                        windowReload();
                    }
                    if(donnees && donnees.status=="ok") {
                        if(params.scope==2 || params.scope==3) {
                            params.category.default_row_id = donnees.category_row_id;
                        }
                        if(params.scope==1 || params.scope==3) {
							var view = findById(params.category.views,params.view_id);
							if (view) {
								view.default_row_id = donnees.view_row_id;
                            }
                        }
                        params.onOk && params.onOk();
                    }else if(params.onError) {
                        params.onError(donnees && donnees.status);
                    }
                },
                error: function() {
                    params.onError && params.onError();
                },
                async: true
            });
        };

        return {
            set: set
        };
    })();


    /**
     * Attempt to return TLang[key] if it exists.
     *
     * prerequisites:
     * -global TLang must an object of key,value containing translations.
     * -global indexNB must exists
     *
     * if TLang[key] does not exist:
     *     -if indexNB==="dev": return "[" + key + "]" to indicate missing a translation
     *     -otherwise: just return key
     * @param  string key The key to lookup in TLang
     * @return string     possible translation (see above)
     */
    var tlang = function(key) {
        if(TLang[key]) {
            return TLang[key];
        }
        return indexNB==="dev" ? ("[" + key + "]") : key;
    };

    var sortUnique = function(arr, compareFunc) {
        if (arr.length == 0) {
            return arr;
        }
        arr = arr.sort(compareFunc);
        var ret = [arr[0]];
        for (var i = 1; i < arr.length; i++) {
            if (compareFunc(arr[i - 1], arr[i]) != 0) {
                ret.push(arr[i]);
            }
        }

        return ret;
    };

    var cancelRowEdit = function(category,row_id,oldFields,options) {

        var defaults = {
            onOk: null,
            onError: null,
            tab_id: null
        };
        options = $.extend({},defaults,options);

        var fields =  category.fields;
        var changes = [];

        var rowIndex = category.rowInfos[row_id].index ;

        var fieldIdToIndex = idToIndex(fields);
        for(var i=0;i<oldFields.length;i++) {
            if(unCancelableTypes[oldFields[i].type]) {
                continue;
            }
            var fieldIndex = fieldIdToIndex[oldFields[i].id];
            if(typeof fieldIndex === 'undefined' || fieldIndex===null) {
                continue;
            }
            var field = fields[fieldIndex];
            field.values[rowIndex].value = oldFields[i].value;
            if(readOnlyTypes[field.type]) {
                continue;
            }
            changes.push({
                field_id: field.id,
                row_id: row_id,
                value: jsonTypes[field.type] &&  field.values[rowIndex].value!==null ?
                    JSON.stringify(field.values[rowIndex].value) : field.values[rowIndex].value
            });
        }

        $.ajax({
            type: "POST",
            dataType: "json",
            url     : apiEndpointUrl + "?changeCarnetFormValue",
            data: {
                indexVNB        : indexVNB,
                session         : sessionNB,
                live            : 'yes',
                newDashboard    : "changeCarnetFormValue",
                values          : changes,
                tab_id          : options.tab_id,
                encryptedFieldPasswords : getEncryptedFieldPasswords(),
                },
                success: function(donnees) {
                    if (donnees=='reload') {
                        windowReload();
                    }

                    if(donnees && donnees.status=="ok") {
                        options.onOk && options.onOk(donnees);
                    }else {
                        options.onError && options.onError(donnees && donnees.status);
                    }
                },error: function() {
                    options.onError && options.onError();
                },
                async: true
        });
    };

    var deleteCategoryRow = function(category,row_id,options) {
         var defaults = {
            onOk: null,
            onError: null,
            permanently: false,
            tab_id: null
        };
        options = $.extend({},defaults,options);

        deleteFormRows(category,[row_id]);

        $.ajax({
            type: "POST",
            dataType: "json",
            url     : apiEndpointUrl + "?deleteCarnetFormRow",
            data: {
                indexVNB        : indexVNB,
                session         : sessionNB,
                live            : 'yes',
                newDashboard    : "deleteCarnetFormRow",
                category_id     : category.id,
                row_ids         : [row_id],
                permanently     : options.permanently,
                tab_id          : options.tab_id
            },
            success: function(donnees) {
                if (donnees=='reload') {
                    windowReload();
                }

                if(donnees && donnees.status=="ok") {
                    options.onOk && options.onOk(donnees);
                }else {
                    options.onError && options.onError(donnees && donnees.status);
                }
            },error: function() {
                options.onError && options.onError();
            },
            async: true
        });

    };

    var fieldChangeRequireRefresh = function(category,field) {

        if(field.type=='lookup') {
            return true;
        }

        var isSelfLinkLocal = isSelfLink.bind(null,category);

        if(field.type=='link') {
            if(isSelfLinkLocal(field) ||  linkHasLookup(category.fields,field)) {
                return true;
            }
        }

        if(fieldHasFormula(category.fields,field)) {
            return true;
        }

        //last, test if field is referenced by a self link
        if(category.fields[0].id==field.id && find(isSelfLinkLocal,category.fields)) {
            return true;
        }

        //or a self lookup
        // var isLookupToField = function(f) {
        //  return f.type=="lookup" && f.lookup.field.id==field.id;
        // };

        // if(find(isLookupToField,category.fields)) {
        //  return true;
        // }
        return false;
    };


    var includeHiddenFields = function(category,forRowEditOrForView) {
    		if(!category || !category.fields)
    			return false;
        if(!category.hiddenFields.length) {
            return category.fields.concat([]);
        }
        var hiddenFields = category.hiddenFields;

        if(forRowEditOrForView) {
            if(typeof forRowEditOrForView === 'object' && forRowEditOrForView.restrictions) {
                hiddenFields = hiddenFields.filter(function(field) {
                    return forRowEditOrForView.restrictions[field.id]==2;
                });
            }else {
                hiddenFields = hiddenFields.filter(function(field) {
                    return field.includeInRowEdit;
                });
            }
        }
        hiddenFields = hiddenFields.map(function(field) {
            return $.extend(field,{hidden: true, hiddenField: false});
        });
        var fields = category.fields.concat(hiddenFields).sort(function(a,b) {
            return a.order-b.order;
        });
        return fields;
    };

    var isSelfLink = function(category,field) {
        return field.type=="link" && field.link.category.id==category.id;
    };

    var fieldValueChangeHasPossibleImpactOnOtherRows = function(category,field) {
        if(isSelfLink(category,field)) {
            return true;
        }

        var fields = includeHiddenFields(category);
        var hasSelfLinks = find(isSelfLink.bind(null,category),fields);
        if(!hasSelfLinks) {
            return false;
        }
        if(fields[0].id===field.id) {
            return true;
        }

        return false;

    };

    /**
     * Check that presentation config fields are not into hidden by view fields or forbidden
     * fields.
     */
    var ViewAccess = (function() {
        var OK = 1,
            HIDDEN_BY_VIEW = 2,
            FORBIDDEN = 3;

        var check = function(category,view,prefKey) {
            var fieldKeys = {
                card: ["hz_field_id","title_field_id","co_field_id"],
                calendar: ["co_field_id","display_field_id","end_field_id","start_field_id"]
            },keys = fieldKeys[prefKey];

            if(!keys) {
                return OK;
            }

            var hiddenByView = toSet(view.hiddenFields);
            var splitted = partition(function(field) {
                return hiddenByView[field.id];
            },category.hiddenFields);

            var forbiddenFields = toAssoc("id",splitted.b);
            var hiddenFields = toAssoc("id",splitted.a);

            for(var i=0;i<keys.length;i++) {
                var field_id = view[prefKey][keys[i]];
                if( ! field_id ) {
                    continue;
                }

                if(forbiddenFields[field_id]) {
                    return FORBIDDEN;
                }
                if(hiddenFields[field_id]) {
                    return HIDDEN_BY_VIEW;
                }
            }

            return OK;
        };

        return {
            OK: OK,
            FORBIDDEN: FORBIDDEN,
            HIDDEN_BY_VIEW: HIDDEN_BY_VIEW,
            check: check
        };

    })();

    var partition = function(predicate,items) {
        var a=[],b=[];
        for(var i=0;i<items.length;i++) {
            if(predicate(items[i])) {
                a.push(items[i]);
            }else {
                b.push(items[i]);
            }
        }

        return {
            a: a,
            b: b
        };
    };


    var exportedFileName = function(params) {
        var fileName = 'TimeTonic-'+
            params.carnet_code +
            '-' +
            params.category.name +
            '-' +
            params.view.name +
            params.fileType;

        fileName = fileName.replace(/\s/g,'');
        fileName = fileName.replace(/[^\w\.\-]/gi,'');

        return fileName;
    };


    var SysFunc = (function() {
        var MEMBER = 1;
        var sysFuncs = [MEMBER];

        var fullType = function(field) {
            return field.type==="link" &&
                field.link &&
                field.link.category &&
                field.link.category.sysFunc ?
                    ("link."+field.link.category.sysFunc) :
                    field.type;
        };

        function isSysField(field) {
            return  field.sysFunc && field.sysFunc != 0;
        }

        return {
            MEMBER: MEMBER,
            sysFuncs: sysFuncs,
            fullType: fullType,
            isSysField: isSysField,
        };
    })();

    var LookupPresentation = {
        CLASSIC: 1,
        TAGS: 2
    };

    function resolvePivotLinkIds(fields,rowInfo) {
        return rowInfo.map(function(info) {
            if(!info.linkId) {
                return info;
            }
            var field = findById(fields,info.linkId);
            if(!field) {
                return null;
            }
            var newInfo = $.extend({},info,{
                id: field.id,
                type: field.type
            });
            delete newInfo.linkId;
            return newInfo;
        });
    }

    function pivotHasVerticalDate(category,parentCat) {
        return (
            category.p_field_vt && 
            FormPro.find(function(field) { 
                return field.id==category.p_field_vt && field.type==="date";
            },parentCat.fields)
        );
    }

    function pivotHasFilterField(category) {
        return (
            category.p_field_fltr
            && category.p_field_fltr !== null
            && category.p_field_fltr != ""
        );
    }

    function saveLinkViewId(field_id,origin_view_id,view_id,onOk) {
        $.ajax({
            dataType: "json",
            url     : apiEndpointUrl,
            data: {
                indexVNB        : indexVNB,
                session         : sessionNB,
                live            : 'yes',
                newDashboard    : "changeLinkViewId",
                field_id        : field_id,
                origin_view_id  : origin_view_id,
                view_id         : view_id
            },
            success: function(donnees) {
                onOk && onOk(donnees.lastModified);
            },
            async: true
        });
    }

    function rowIdToIndex(category,row_id) {
        var rowInfo = category.rowInfos[row_id];
        if(!rowInfo) {
            return -1;
        }
        if(!rowInfo.hasOwnProperty('index')) {
            return -1;
        }
        return rowInfo.index*1;
    }

    function getAddRowEnabled(category) {
        return !((category.locked && category.locked==1) || category.forbidAddRow);
    }

    function getAddRowInPlaceEnabled(category) {
        return !((category.locked && category.locked!=3) || category.forbidAddRow);
    }

    function presentation(category,view) {
        return category.pivot_id ? "pivot" : (view.presentation*1);
    }

    function compareFilterRowIds(oldFilterRowIds,newFilterRowIds) {
        if(oldFilterRowIds===null || newFilterRowIds===null) {
            return oldFilterRowIds===newFilterRowIds;
        }

        if(oldFilterRowIds.changeSelectedView!==newFilterRowIds.changeSelectedView ||
            oldFilterRowIds.quickSearch!==newFilterRowIds.quickSearch) {
            return false;
        }

        var oldApplyViewFilters=oldFilterRowIds.applyViewFilters,
            newApplyViewFilters=newFilterRowIds.applyViewFilters;
        if(!oldApplyViewFilters || !newApplyViewFilters) {
            if(oldApplyViewFilters!==newApplyViewFilters) {
                return false;
            }
        }else if( isViewObject(oldApplyViewFilters) &&  isViewObject(oldApplyViewFilters) ) {
            if(oldApplyViewFilters._filtersStamp!==newApplyViewFilters._filtersStamp ) {
                return false;
            }
        }else if(oldApplyViewFilters!==newApplyViewFilters) {
            return false;
        }
        

        var oldMoreFilters = oldFilterRowIds.moreFilters,
            newMoreFilters = newFilterRowIds.moreFilters;
        if(!oldMoreFilters || !newMoreFilters) {
            if(oldMoreFilters!==newMoreFilters) {
                return false;
            }
        }else if(oldMoreFilters._filtersStamp!==newMoreFilters._filtersStamp) {
            return false;
        }

        if(oldFilterRowIds.row_ids!==newFilterRowIds.row_ids) {
            return false;
        }
        return true;

        function isViewObject(maybeView) {
            return maybeView && typeof maybeView === "object" && maybeView.id && maybeView.name;
        }
    }

    function appendRowInfos(category,rowInfos) {
        var addedCount = 0,receivedCount=0;
        for (var row_id in rowInfos) {
            if (!hasOwnProperty.call(rowInfos, row_id)) {
                continue;
            }
            receivedCount ++;
            if( (category.rowInfos[row_id]) ) {
                continue;
            }
            category.rowInfos[row_id] = rowInfos[row_id];
            addedCount ++;
        }
        category.rowInfosLength += addedCount;
        return {addedCount: addedCount,receivedCount: receivedCount};
    }

    var encryptedFieldPasswords = {};
    function setEncryptedFieldPassword(field_id,password) {
        encryptedFieldPasswords[field_id] = password;
    }

    function deleteEncryptedFieldPassword(field_id) {
        delete encryptedFieldPasswords[field_id];
    }

    function cleanEncryptedFieldPasswords() {
        encryptedFieldPasswords = {};
    }

    function getEncryptedFieldPasswords() {
        return Object.assign({},encryptedFieldPasswords);
    }

    //exports
    return {
        displayFilterDialog: displayFilterDialog,
        RecordFilterGroup: RecordFilterGroup,
        RecordFilterFactory: RecordFilterFactory,
        generatePivotTableData_new: generatePivotTableData_new,
        formatJSONCell: formatJSONCell,
        formatJSONLinkCell: formatJSONLinkCell,
		isFieldNumeric: isFieldNumeric,
        isFieldTypeNumeric: isFieldTypeNumeric,
        findCategoryById: findCategoryById,
        findSelectedViewIndex: findSelectedViewIndex,
        findSelectedView: findSelectedView,
        findCategoryIndexById: findCategoryIndexById,
        parseDate: parseDate,
        isValidDate: isValidDate,
        extractDistinctValues: extractDistinctValues,
        findIndexById: findIndexById,
        searchFiles: searchFiles,
        searchComments: searchComments,
        bindStrParams: bindStrParams,
        findById: findById,
		linkTypes: linkTypes,
		colorTypes: colorTypes,
        enumForeignTypes: enumForeignTypes,
        numberTypes: numberTypes,
        lookupTypes: lookupTypes,
        isValueFile: isValueFile,
        hasLinkToCurrent: hasLinkToCurrent,
        findDependingLookups: findDependingLookups,
        linkHasLookup: linkHasLookup,
        extractAstFields: extractAstFields,
        fieldHasFormula: fieldHasFormula,
        formulaTypes: formulaTypes,
        simpleTypes: simpleTypes,
        cardTypes: cardTypes,
        cardTitleTypes: cardTitleTypes,
        calendarTypes: calendarTypes,
        findIndex: findIndex,
        propEq: propEq,
        valEq: valEq,
        anyPass: anyPass,
        allPass: allPass,
        typeConversions: typeConversions,
        toAssoc: toAssoc,
        find: find,
        jsonTypes: jsonTypes,
        compareArrays: compareArrays,
        unCancelableTypes: unCancelableTypes,
        readOnlyTypes: readOnlyTypes,
        formatDate: formatDate,
        formatDateValue: formatDateValue,
        numeralFormat: numeralFormat,
        defaultDateFormat: defaultDateFormat,
        linkValueAsText: linkValueAsText,
        valueAsText: valueAsText,
        getLinkTargetField: getLinkTargetField,
        fieldHasColors: fieldHasColors,
        strToCssClass: strToCssClass,
        addNewOption: addNewOption,
        convertUtilisateur: convertUtilisateur,
		findEnumColor: findEnumColor,
		findLinkColorField: findLinkColorField,
        toBoolean: toBoolean,
        idToIndex: idToIndex,
        generateTmpRowId: generateTmpRowId,
        linkWithJustRowId: linkWithJustRowId,
        fieldProp: fieldProp,
        fieldWithValueProp: fieldWithValueProp,
        hasTimeAndDate: hasTimeAndDate,
        SysFunc: SysFunc,
        colorIsLight: colorIsLight,
        convertBitsToBytes: convertBitsToBytes,
        activateSSF: activateSSF,
        replaceCategoryData: replaceCategoryData,
        transferModifiedViewsInForm : transferModifiedViewsInForm,
        transferModifiedViews : transferModifiedViews,
        ensureModifiedViewsValid : ensureModifiedViewsValid,
        caseOf: caseOf,
        getLazyLoadingMaxRows: getLazyLoadingMaxRows,
        enableLazyLoading: enableLazyLoading,
        fillArray: fillArray,
        lazyLoader: lazyLoader,
        toIdSet: toIdSet,
        findKeyInObject: findKeyInObject,
        safeAccess: safeAccess,
        objectValues: objectValues,
        applyNewRowOrder: applyNewRowOrder,
        deleteFormRows: deleteFormRows,
        parseNumber: parseNumber,
        NotifSubscribe: NotifSubscribe,
        equalizeValuesLengths: equalizeValuesLengths,
        filterObject: filterObject,
        TabType: TabType,
        DuplicateRow: DuplicateRow,
        tlang: tlang,
        DefaultRow: DefaultRow,
        sortUnique: sortUnique,
        mapObjectToArray: mapObjectToArray,
        mapObject: mapObject,
        isObjectEmpty: isObjectEmpty,
        enumColorValuesToObj: enumColorValuesToObj,
        toEnumColorMatchingValue: toEnumColorMatchingValue,
        cancelRowEdit: cancelRowEdit,
        deleteCategoryRow: deleteCategoryRow,
        fieldChangeRequireRefresh: fieldChangeRequireRefresh,
        includeHiddenFields: includeHiddenFields,
        toSet: toSet,
        fieldValueChangeHasPossibleImpactOnOtherRows: fieldValueChangeHasPossibleImpactOnOtherRows,
        generateTmpFilterId: generateTmpFilterId,
        ViewAccess: ViewAccess,
        partition: partition,
        exportedFileName: exportedFileName,
        objectHasValue: objectHasValue,
        addNewMask: addNewMask,
        LookupPresentation: LookupPresentation,
		findEnumColorValue: findEnumColorValue,
        resolvePivotLinkIds: resolvePivotLinkIds,
        pivotHasVerticalDate: pivotHasVerticalDate,
        getPivotDateExtend: getPivotDateExtend,
        saveLinkViewId: saveLinkViewId,
        rowIdToIndex: rowIdToIndex,
        getAddRowEnabled: getAddRowEnabled,
        getAddRowInPlaceEnabled: getAddRowInPlaceEnabled,
        isTmpRowId: isTmpRowId,
        enableFilterOnKeyUp: enableFilterOnKeyUp,
        presentation: presentation,
        RecordGroupBy: RecordGroupBy,
        getTableValues: getTableValues,
        getLinkValues: getLinkValues,
        getCategory: getCategory, 
        resetPivotTableData_new_fieldGetValues: resetPivotTableData_new_fieldGetValues,
        compareFilterRowIds: compareFilterRowIds,
        appendRowInfos: appendRowInfos,
        moreRowCount: moreRowCount,
        pivotHasFilterField: pivotHasFilterField,
        createColInfoButton: createColInfoButton,
        setEncryptedFieldPassword: setEncryptedFieldPassword,
        cleanEncryptedFieldPasswords: cleanEncryptedFieldPasswords,
        getEncryptedFieldPasswords: getEncryptedFieldPasswords,
        deleteEncryptedFieldPassword: deleteEncryptedFieldPassword,
    };

})(typeof $ === 'undefined' ? undefined : $);

export default FormProInternal;



// WEBPACK FOOTER //
// ./src/jquery.formpro-common.js